<template>
    <div
        class="carFilterContainer"
        :class="[{ 'filter-active': isMobileFilterOpen, 'bg-grey': siteId === 5 }, siteId ? 'site-' + siteId : null]"
    >
        <!-- Flash Messages -->
        <FlashMessage />

<!--        &lt;!&ndash; loading overlay &ndash;&gt;-->
<!--        <div v-if="loading" class="loading-overlay">-->
<!--            <div class="overlay-backdrop"></div>-->
<!--            <div class="spinner-container d-flex align-items-center">-->
<!--                <svg class="spinner-icon me-3" viewBox="0 0 50 50">-->
<!--                    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"/>-->
<!--                </svg>-->
<!--                <span class="spinner-text">{{ props.loadingLabel }}</span>-->
<!--            </div>-->
<!--        </div>-->

        <!-- mobile breadcrumbs - shown only on mobile -->
        <section class="section section--breadcrumb py-0 mb-3 d-block d-lg-none breadcrumb-placeholder">
            <div class="container container--medium">
                <div class="border-top border-bottom py-3">
                    <Breadcrumbs :items="breadcrumbs" :loading="loading" :is-initial-load="isInitialLoad" :placeholder-count="3" />
                </div>
            </div>
        </section>

        <!-- filter banner - always render container to prevent layout shifts -->
        <section v-if="bannerSlides.length || loading || siteId !== 5" class="filter-banner section p-0 mb-2 banner-placeholder">
            <div class="container container--wide">
              <component
                  :is="BannerSlider"
                  :slides="bannerSlides"
                  :getSlideImage="getSlideImage"
                  :autoplayInterval="5000"
                  :loading="loading"
                  :is-initial-load="isInitialLoad"
              />
            </div>
        </section>


        <!-- breadcrumbs -->
        <section v-if="siteId !== 5" class="section section--breadcrumb py-0 mb-3 d-none d-lg-block">
            <div class="container container--medium">
                <div class="border-top border-bottom py-3 d-lg-flex justify-content-between align-items-center">
                    <Breadcrumbs :items="breadcrumbs" :loading="loading" :is-initial-load="isInitialLoad" :placeholder-count="3" />

                    <!-- Skeleton pro toggle během prvotního loadu a při načítání -->
                    <div v-if="isInitialLoad || loading" class="skeleton-toggle d-flex align-items-center">
                        <div class="skeleton-toggle-switch"></div>
                        <div class="skeleton-toggle-text"></div>
                    </div>

                    <!-- Skutečný toggle až když je načteno -->
                    <div v-else class="form-check form-switch">
                        <input
                            v-model="listDisplayType"
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="displayRows"
                            value="1"
                        >
                        <label
                            class="form-check-label text--16px"
                            for="displayRows"
                        >
                            {{ props.listViewToggle }}
                        </label>
                    </div>
                </div>
            </div>
        </section>

        <!-- filter + results -->
        <section class="section section--filter overflow-hidden pt-0">
            <div class="container container--medium">

                <!-- mobile title -->
                <div :class="['text--28px my-4 d-lg-none text-center text-lg-start', siteId === 6 ? 'text--white' : 'text-primary']">
                    {{ pageTitle }}
                </div>

                <!-- Show Filter button for mobile -->
                <div ref="showFilterWrap" id="showFilterWrap" class="d-lg-none w-100 mb-3">
                    <div class="showFilterBar">
                        <button
                            id="showFilter"
                            type="button"
                            class="btn btn-primary btn-filter d-flex align-items-center justify-content-center text-nowrap w-100"
                            @click="openMobileFilter"
                        >
                            {{ props.mobileFilterTitle }}
                            <img :src="siteId === 6 ? '/images/lynkac/icons/ico-filter.svg' : '/images/icons/ico-filter.svg'" alt="" class="icon icon--w16 ms-2">
                            <span :class="['counter', siteId === 6 ? 'counter--lynkac' : '']">
                                {{ badgeItems.length }}
                            </span>
                        </button>
                    </div>
                </div>
                <!-- Sentinel -->
                <div ref="sentinelShowFilterWrap" id="sentinelShowFilterWrap"></div>

                <div class="filter d-flex align-items-start">
                    <!-- sidebar -->
                    <div class="filter__controls-wrapper" @click="handleFilterControlsClick">
                        <component
                            v-if="siteId || loading"
                            :is="CarFilterSidebar"
                            :filters="filters"
                            :options="options"
                            :present-data="presentData"
                            :loading="loading"
                            :is-initial-load="isInitialLoad"
                            :props-data="{ ...props, total: total }"
                            :histogram="histogramData"
                            :format-range="formatRange"
                            :mileage-ranges-translations="props.mileageRangesTranslations"
                            :age-ranges-translations="props.ageRangesTranslations"
                            :price-ranges-translations="props.priceRangesTranslations"
                            :max-mileage="maxMileage"
                            :max-age="maxAge"
                            v-model:selectedMileageRange="selectedMileageRange"
                            v-model:selectedAgeRange="selectedAgeRange"
                            v-model:selectedPriceRange="selectedPriceRange"
                            :additional-attributes-button-label="props.additionalAttributesButtonLabel"
                            :additional-attributes-modal-title-long="props.additionalAttributesModalTitleLong"
                            :additional-attributes-modal-title-short="props.additionalAttributesModalTitleShort"
                            :additional-attributes-modal-btn-cancel="props.additionalAttributesModalBtnCancel"
                            :additional-attributes-modal-btn-save="props.additionalAttributesModalBtnSave"
                            @update-filters="updateFilters"
                            @hide-filter="closeMobileFilter"
                            @clear-filters="clearFilters"
                        />
                        <div v-else-if="!siteId && !loading" class="filter__controls border rounded p-lg-4 d-flex justify-content-center align-items-center" style="min-height: 200px;">
                            <div class="text-center">
                                <div class="spinner-border text-primary mb-3" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <div class="visually-hidden">{{ props.loadingLabel }}</div>
                            </div>
                        </div>

                        <!-- Filter Backdrop -->
                        <div class="filter__backdrop" @click="closeMobileFilter"></div>
                    </div>

                    <!-- results -->
                    <component
                        v-if="siteId || loading"
                        :is="CarFilterResults"
                        :offers="offers"
                        :loading="loading"
                        :is-initial-load="isInitialLoad"
                        :page-title="pageTitle"
                        :total-results-final-text="totalResultsFinalText"
                        :badge-items="badgeItems"
                        :model-series-chips="modelSeriesChips"
                        :comparison-list="comparisonList"
                        :favorites="favorites"
                        :current-page="currentPage"
                        :last-page="lastPage"
                        :sort="sort"
                        v-model:list-display-type="listDisplayType"
                        :props-data="{ ...props, siteId, lang }"
                        :open-dropdown-id="openDropdownId"
                        :seo-headline="seoHeadline"
                        :seo-description="seoDescription"
                        @fetch-results="(page, isLoadMore) => fetchResults(page, isLoadMore)"
                        @add-to-comparison="addToComparison"
                        @remove-from-comparison="removeFromComparison"
                        @add-to-favorites="addToFavorites"
                        @remove-from-favorites="removeFromFavorites"
                        v-model:sort="sort"
                        @toggle-dropdown="onToggleDropdown"
                        @remove-filter="removeFilter"
                        @clear-filters="clearFilters"
                        @clear-comparison="clearComparisonList"
                        @car-selected="handleCarSelected"
                    />
                    <div v-else-if="!siteId && !loading" class="filter__results d-flex justify-content-center align-items-center" style="min-height: 400px;">
                        <div class="text-center">
                            <div class="spinner-border text-primary mb-3" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            <div class="visually-hidden">{{ props.loadingLabel }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- bottom banner -->
        <section v-if="bottomBannerSlides.length" class="filter-banner section section--teaser teaser teaser--small p-0 mt-5">
            <div class="container container--wide">
              <component
                  :is="BannerSlider"
                  :slides="bottomBannerSlides"
                  :getSlideImage="getSlideImage"
                  :autoplayInterval="5000"
              />
            </div>
        </section>
    </div>

    <!-- Save Filter Modal -->
    <component
        :is="SaveCarFilterModalComponent"
        :currentFilterSettings="getCurrentFilterSettings()"
        :currentFilterResults="getCurrentFilterResults()"
        :translations="saveFilterTranslations"
    />
</template>

<script setup>
import { ref, reactive, computed, watch, onMounted, onUnmounted, nextTick } from 'vue'
import axios from 'axios'
import BannerSliderDefault from '@/components/CarFilter/BannerSlider.vue'
import Breadcrumbs from '@/components/CarFilter/Breadcrumbs.vue'
import CarFilterSidebarDefault from '@/components/CarFilter/CarFilterSidebar.vue'
import CarFilterResultsDefault from '@/components/CarFilter/CarFilterResults.vue'
import SaveCarFilterModal from '@/components/CarFilter/SaveCarFilterModal.vue'
import FlashMessage from '@/components/FlashMessage.vue'
import flashMessageService from '@/services/flashMessageService'
import { getSiteSpecificComponent, SITE_SLUGS } from '@/car-filter'

// Dynamically load site-specific components or use defaults
const BannerSlider = computed(() => {
    // Always use site ID for consistency
    return getSiteSpecificComponent('BannerSlider', siteId.value, BannerSliderDefault);
})
const CarFilterSidebar = computed(() => {
  // Always use site ID for consistency
  return getSiteSpecificComponent('CarFilterSidebar', siteId.value, CarFilterSidebarDefault);
})
const CarFilterResults = computed(() => {
  // Always use site ID for consistency
  return getSiteSpecificComponent('CarFilterResults', siteId.value, CarFilterResultsDefault);
})
const SaveCarFilterModalComponent = computed(() => {
  // Always use site ID for consistency
  return getSiteSpecificComponent('SaveCarFilterModal', siteId.value, SaveCarFilterModal);
})

function normalizeSiteId(value) {
    if (value === null || value === undefined || value === '') {
        return null
    }

    const siteId = Number(value)

    return Number.isNaN(siteId) ? null : siteId
}

// Configure axios to send CSRF token with every request
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
const token = document.head.querySelector('meta[name="csrf-token"]')
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
    // Also set the XSRF-TOKEN cookie value as X-XSRF-TOKEN header
    axios.defaults.withCredentials = true
} else {
    // console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

// Image purpose constants
const IMAGE_PURPOSES = {
    PURPOSE_BANNER_SMALL_IMAGE: 73,
    PURPOSE_BANNER_MEDIUM_IMAGE: 72,
    PURPOSE_BANNER_LARGE_IMAGE: 71,
    PURPOSE_BANNER_XLARGE_IMAGE: 74,
}

// Props
const props = defineProps({
    loadingLabel:             { type: String, required: true },
    mobileFilterTitle:        String,
    statusLabel:              String,
    btnShowShowrooms:         String,
    moreValuesText:           String,
    showMoreResults:          String,
    showResultsCountLabel:    String,
    filterActionLabel:        String,
    noImagesText:             String,
    badgeVolvoSelekt:         String,
    badgeTipcarsApproved:     String,
    badgeVatDeductible:       String,
    badgeInStock:             String,
    listViewToggle:           String,
    showroomLabel:            String,
    brandLabel:               String,
    categoryLabel:            String,
    actionDealsLabel:         String,
    modelLabel:               String,
    fuelTypeLabel:            String,
    transmissionTypeLabel:    String,
    bodyTypeLabel:            String,
    bodyColorLabel:           String,
    mileageLabel:             String,
    ageLabel:                 String,
    priceLabel:               String,
    totalResultsFinal:        String,
    sortByLabel:              String,
    sortingOptions:           Object,
    lblFrom:                  String,
    lblMonthlyInclVat:        String,
    lblMonthlyExclVat:        String,
    lblExclVatSimple:         String,
    lblAddToFavorites:        String,
    lblRemoveFromFavorites:   String,
    lblAddToComparison:       String,
    lblRemoveFromComparison:  String,
    lblAddedToFavorites:      String,
    lblRemovedFromFavorites:  String,
    lblAddedToComparison:     String,
    lblRemovedFromComparison: String,
    lblDropdownAddToFavorites:       String,
    lblDropdownRemoveFromFavorites:  String,
    lblDropdownAddToComparison:      String,
    lblDropdownRemoveFromComparison: String,
    lblComparedCarsLimitReached: String,
    lblShare:                 String,
    lblDetails:               String,
    lblShow:                  String,
    lblMoreActions:           String,
    volvoSelektTooltip:       String,
    badgeTranslations:        Object,
    mileageRangesTranslations: Object,
    ageRangesTranslations:     Object,
    priceRangesTranslations:   Object,
    clearAllLabel:            String,
    removeFilterLabel:        String,
    btnShowMoreSeoText:       String,
    btnShowLessSeoText:       String,
    additionalAttributesButtonLabel: String,
    additionalAttributesModalTitleLong: String,
    additionalAttributesModalTitleShort: String,
    additionalAttributesModalBtnCancel: String,
    additionalAttributesModalBtnSave: String,
    saveFilterLabel:          { type: String, default: 'Uložit filtr' },
    saveFilterNoteLabel:      { type: String, default: 'Uložte si filtr a dostávejte upozornění na nové vozy' },
    reviewsTitle:             { type: String, required: true },
    comparisonHeaderLabel:    { type: String, required: true },
    comparisonCompareButtonLabel: { type: String, required: true },
    comparisonResetButtonLabel: { type: String, required: true },
    comparisonRemoveLabel:    { type: String, required: true },
    comparisonUrl:            { type: String, required: true },
    initialSeoTitle:          { type: String, required: true },
    initialMetaDescription:   { type: String, required: true },
    saveFilterTranslations:   { type: Object, required: true },
    initialOffers:            { type: Array, default: () => [] },
    initialTotal:             { type: Number, default: 0 },
    initialTotalNoFilter:     { type: Number, default: 0 },
    initialCurrentPage:       { type: Number, default: 1 },
    initialLastPage:          { type: Number, default: 1 },
    initialPageTitle:         { type: String, default: 'Všechny vozy' },
    initialBreadcrumbs:       { type: Array, default: () => [] },
    initialSeoHeadline:       { type: String, default: '' },
    initialSeoDescription:    { type: String, default: '' },
    initialSiteId:            { type: [String, Number], default: null },
    initialLang:              { type: String, default: null },
    initialPresent:           { type: Object, default: () => ({}) },
    // Default filter props
    defaultCategoryId:        { type: [String, Number], default: null },
    defaultBodyTypeId:        { type: [String, Number], default: null },
    defaultFuelTypeId:        { type: [String, Number], default: null },
    defaultCarModelId:        { type: [String, Number], default: null },
    defaultAvailabilityTypeId: { type: [String, Number], default: null },
    defaultVolvoSelekt:       { type: [String, Boolean], default: false },
    defaultIsInStock:         { type: [String, Boolean], default: false },
    defaultBrandId:           { type: [String, Number], default: null },
    titleSuffix:              { type: String, default: '' },
    currencyCode:             { type: String, default: 'CZK' },
    hreflangSites:            { type: Array, default: () => [] },
})

// State
const hasInitialResults            = Array.isArray(props.initialOffers)
const isInitialLoad                = ref(true)
const isHydrated                   = ref(false)
const loading                      = ref(false)
const offers                       = ref(props.initialOffers)
const total                        = ref(props.initialTotal)
const totalNoFilter                = ref(props.initialTotalNoFilter)
const currentPage                  = ref(props.initialCurrentPage)
const lastPage                     = ref(props.initialLastPage)
const sort                         = ref('newest')
const listDisplayType              = ref(false)
const isMobileFilterOpen           = ref(false)
const lazyPrevPages                = ref(0)

const breadcrumbs                  = ref(props.initialBreadcrumbs)
const pageTitle                    = ref(props.initialPageTitle)
const seoTitle                     = ref(props.initialSeoTitle)
const metaDescription              = ref(props.initialMetaDescription)
const seoHeadline                  = ref(props.initialSeoHeadline)
const seoDescription               = ref(props.initialSeoDescription)
const siteId                       = ref(normalizeSiteId(props.initialSiteId))
const lang                         = ref(props.initialLang)

const comparisonList               = ref([])
const favorites                    = ref([])
const openDropdownId               = ref(null)
const modelSeriesChips             = ref([])

const comparisonCarDetailsCache    = new Map()
const COMPARISON_DETAILS_CACHE_LIMIT = 200

// Banner slides
const bannerSlides                 = ref([])
const bottomBannerSlides           = ref([])
// All banner slides (cached)
const allBannerSlides              = ref(null)

// Range filters
const selectedMileageRange         = ref('-')
const selectedAgeRange             = ref('-')
const selectedPriceRange           = ref('-')
const isSyncingSelectedPriceRange  = ref(false)

// Initialize with default values only when partial values are provided
const initRangeFilters = () => {
    const currentYear = new Date().getFullYear()
    const defaultAgeFrom = 1990 // Same default as in buildParams
    const defaultAgeTo = currentYear // Same default as in buildParams
    const defaultMileageFrom = 0 // Same default as in buildParams
    // Round maxMileage up to nearest 10k with minimum 300k
    const defaultMileageTo = Math.max(300000, Math.ceil(maxMileage.value / 10000) * 10000)

    // Only initialize age filters if one is set but not the other (partial values)
    // Don't set defaults if both are null (no filter applied)
    if (filters.ageFrom !== null && filters.ageTo === null) {
        // If only ageFrom is set, set ageTo to current year
        filters.ageTo = defaultAgeTo
    } else if (filters.ageFrom === null && filters.ageTo !== null) {
        // If only ageTo is set, set ageFrom to default value
        filters.ageFrom = defaultAgeFrom
    }

    // Only initialize mileage filters if one is set but not the other (partial values)
    // Don't set defaults if both are null (no filter applied)
    if (filters.mileageFrom !== null && filters.mileageTo === null) {
        // If only mileageFrom is set, set mileageTo to default value
        filters.mileageTo = defaultMileageTo
    } else if (filters.mileageFrom === null && filters.mileageTo !== null) {
        // If only mileageTo is set, set mileageFrom to default value
        filters.mileageFrom = defaultMileageFrom
    }

    // Don't initialize price filters with default values
    // This ensures that price filter values from URL parameters are preserved
}

const maxMileage = ref(0)
const maxAge     = ref(0)

// Filters object
const filters = reactive({
    brands:              [],
    availabilityTypes:   [],
    showrooms:           [],
    models:              [],
    fuelTypes:           [],
    transmissionTypes:   [],
    bodyTypes:           [],
    bodyColors:          [],
    categories:          [],
    priceFrom:           null,
    priceTo:             null,
    mileageFrom:         null,
    mileageTo:           null,
    ageFrom:             null,
    ageTo:               null,
    vatDeductibleOnly:   false,
    volvoSelektOnly:     false,
    tipcarsApprovedOnly: false,
    isInStock:           false,
    additionalAttributes:{},
    customTags:          [],
})

// Options
const options = ref({
    brands:            [],
    availabilityTypes: [],
    showrooms:         [],
    models:            [],
    fuelTypes:         [],
    transmissionTypes: [],
    bodyTypes:         [],
    bodyColors:        [],
    categories:        [],
    additionalAttributes: [],
    customTags:        []
})

// Present counts
const presentBrands                = ref({})
const presentAvailabilityTypes     = ref({})
const presentShowrooms             = ref({})
const presentModels                = ref({})
const presentFuelTypes             = ref({})
const presentTransmissionTypes     = ref({})
const presentBodyTypes             = ref({})
const presentBodyColors            = ref({})
const presentCategories            = ref({})
const presentMileageRanges         = ref({})
const presentAgeRanges             = ref({})
const presentPriceRanges           = ref({})
const presentVolvoSelektResults    = ref(0)
const presentTipcarsApprovedResults= ref(0)
const presentVatDeductibleResults  = ref(0)
const presentIsInStockResults      = ref(0)
const presentAdditionalAttributes  = ref({})
const presentCustomTags            = ref({})

function applyPresentData(present = {}) {
    presentBrands.value                = present.brands || {}
    presentAvailabilityTypes.value     = present.availabilityTypes || {}
    presentShowrooms.value             = present.showrooms || {}
    presentModels.value                = present.models || {}
    presentFuelTypes.value             = present.fuelTypes || {}
    presentTransmissionTypes.value     = present.transmissionTypes || {}
    presentBodyTypes.value             = present.bodyTypes || {}
    presentBodyColors.value            = present.bodyColors || {}
    presentCategories.value            = present.categories || {}
    presentMileageRanges.value         = present.mileageRanges || {}
    presentAgeRanges.value             = present.ageRanges || {}
    presentPriceRanges.value           = present.priceRanges || {}
    presentVolvoSelektResults.value    = present.volvoSelekt || 0
    presentTipcarsApprovedResults.value = present.tipcarsApproved || 0
    presentVatDeductibleResults.value  = present.vatDeductible || 0
    presentIsInStockResults.value      = present.inStock || 0
    presentAdditionalAttributes.value  = present.additionalAttributes || {}
    presentCustomTags.value            = present.customTags || {}
}

applyPresentData(props.initialPresent)

function getUpperBoundPriceRangeKey(priceTo) {
    if (priceTo == null) {
        return null
    }

    const key = `-${Number(priceTo)}`

    return Object.prototype.hasOwnProperty.call(presentPriceRanges.value, key) ? key : null
}

const histogramData = ref({
    min: 0,
    max: 0,
    histogram: [],
})

// Combined present data
const presentData = computed(() => ({
    brands:              presentBrands.value,
    availabilityTypes:   presentAvailabilityTypes.value,
    showrooms:           presentShowrooms.value,
    models:              presentModels.value,
    fuelTypes:           presentFuelTypes.value,
    transmissionTypes:   presentTransmissionTypes.value,
    bodyTypes:           presentBodyTypes.value,
    bodyColors:          presentBodyColors.value,
    categories:          presentCategories.value,
    mileageRanges:       presentMileageRanges.value,
    ageRanges:           presentAgeRanges.value,
    priceRanges:         presentPriceRanges.value,
    volvoSelekt:         presentVolvoSelektResults.value,
    tipcarsApproved:     presentTipcarsApprovedResults.value,
    vatDeductible:       presentVatDeductibleResults.value,
    inStock:             presentIsInStockResults.value,
    additionalAttributes: presentAdditionalAttributes.value,
    customTags:          presentCustomTags.value,
}))


const showFilterWrap = ref(null)
const sentinelShowFilterWrap = ref(null)
let observerShowFilterWrap = null
let observedShowFilterWrapElement = null

async function setupShowFilterWrapObserver() {
    if (siteId.value !== 1 || observerShowFilterWrap) {
        return
    }

    await nextTick()

    if (!showFilterWrap.value || !sentinelShowFilterWrap.value || typeof IntersectionObserver === 'undefined') {
        return
    }

    const filterWrapElement = showFilterWrap.value
    const sentinelElement = sentinelShowFilterWrap.value

    observedShowFilterWrapElement = filterWrapElement

    observerShowFilterWrap = new IntersectionObserver(
        ([entry]) => {
            if (!filterWrapElement?.isConnected) {
                return
            }

            if (entry.isIntersecting) {
                filterWrapElement.classList.remove('is-fixed')
            } else {
                const filterBarElement = filterWrapElement.querySelector('.showFilterBar')
                if (filterBarElement) {
                    filterWrapElement.style.setProperty('--show-filter-wrap-height', `${filterBarElement.getBoundingClientRect().height}px`)
                }
                filterWrapElement.classList.add('is-fixed')
            }
        },
        { threshold: 0 }
    )

    observerShowFilterWrap.observe(sentinelElement)
}

function teardownShowFilterWrapObserver() {
    if (observerShowFilterWrap) {
        observerShowFilterWrap.disconnect()
        observerShowFilterWrap = null
    }

    if (observedShowFilterWrapElement?.isConnected) {
        observedShowFilterWrapElement.classList.remove('is-fixed')
    }

    observedShowFilterWrapElement = null
}

function parseBooleanQueryParam(value) {
    if (value === null || value === undefined) {
        return null
    }

    if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase()
        if (normalized === 'true' || normalized === '1') {
            return true
        }
        if (normalized === 'false' || normalized === '0') {
            return false
        }
    }

    if (typeof value === 'number') {
        return value === 1
    }

    if (typeof value === 'boolean') {
        return value
    }

    return null
}

// Total results text
const totalResultsFinalText = computed(() => {
    // TODO: better logic, temp fix:
    // If no filters are applied, show the same number for both total and totalNoFilter
    if (badgeItems.value.length === 0) {
        return props.totalResultsFinal
            .replace('{total}', formatNumber(totalNoFilter.value))
            .replace('{totalNoFilter}', formatNumber(totalNoFilter.value))
    }

    // Otherwise, show the actual filtered count
    return props.totalResultsFinal
        .replace('{total}', formatNumber(total.value))
        .replace('{totalNoFilter}', formatNumber(totalNoFilter.value))
})

const badgeItems = computed(() => {
    const items = []

    // Brands
    options.value.brands.forEach(brand => {
        if (filters.brands.includes(brand.id)) {
            items.push({
                filterName: 'brands',
                filterValue: brand.id,
                label: brand.name,
                filterCategoryLabel: props.brandLabel || null,
            })
        }
    })

    // Availability types
    options.value.availabilityTypes.forEach(type => {
        if (filters.availabilityTypes.includes(type.id)) {
            items.push({
                filterName: 'availabilityTypes',
                filterValue: type.id,
                label: type.name,
                filterCategoryLabel: props.statusLabel || null,
            })
        }
    })

    // Models
    options.value.models.forEach(model => {
        if (filters.models.includes(model.id)) {
            items.push({
                filterName: 'models',
                filterValue: model.id,
                label: model.name,
                filterCategoryLabel: props.modelLabel || null,
            })
        }
    })

    // Showrooms
    options.value.showrooms.forEach(showroom => {
        if (filters.showrooms.includes(showroom.id)) {
            items.push({
                filterName: 'showrooms',
                filterValue: showroom.id,
                label: showroom.name,
                filterCategoryLabel: props.showroomLabel || null,
            })
        }
    })

    // Fuel types
    options.value.fuelTypes.forEach(fuel => {
        if (filters.fuelTypes.includes(fuel.id)) {
            items.push({
                filterName: 'fuelTypes',
                filterValue: fuel.id,
                label: fuel.name,
                filterCategoryLabel: props.fuelTypeLabel || null,
            })
        }
    })

    // Transmission types
    options.value.transmissionTypes.forEach(tr => {
        if (filters.transmissionTypes.includes(tr.id)) {
            items.push({
                filterName: 'transmissionTypes',
                filterValue: tr.id,
                label: tr.name,
                filterCategoryLabel: props.transmissionTypeLabel || null,
            })
        }
    })

    // Body types
    options.value.bodyTypes.forEach(bt => {
        if (filters.bodyTypes.includes(bt.id)) {
            items.push({
                filterName: 'bodyTypes',
                filterValue: bt.id,
                label: bt.name,
                filterCategoryLabel: props.bodyTypeLabel || null,
            })
        }
    })

    // Body colors
    options.value.bodyColors.forEach(bc => {
        if (filters.bodyColors.includes(bc.id)) {
            items.push({
                filterName: 'bodyColors',
                filterValue: bc.id,
                label: bc.name,
                filterCategoryLabel: props.bodyColorLabel || null,
            })
        }
    })

    // Categories
    options.value.categories.forEach(cat => {
        if (filters.categories.includes(cat.id)) {
            items.push({
                filterName: 'categories',
                filterValue: cat.id,
                label: cat.name,
                filterCategoryLabel: props.categoryLabel || null,
            })
        }
    })

    // Price filter
    // Use the same default values as in buildParams function
    const defaultPriceFrom = histogramData.value.min
    const defaultPriceTo = histogramData.value.max

    // Add price from filter badge if value is not null and different from default
    if (filters.priceFrom !== null && filters.priceFrom !== defaultPriceFrom) {
        items.push({
            filterName: 'priceFrom',
            filterValue: filters.priceFrom,
            label: `${props.priceLabel || 'Cena'}: od ${formatNumber(filters.priceFrom)} Kč`,
        })
    }

    // Add price to filter badge if value is not null and different from default
    // Always show the price to badge when price from is set
    if ((filters.priceTo !== null && filters.priceTo !== defaultPriceTo) ||
        (filters.priceFrom !== null && filters.priceFrom !== defaultPriceFrom)) {
        const priceTo = filters.priceTo !== null ? filters.priceTo : defaultPriceTo;
        items.push({
            filterName: 'priceTo',
            filterValue: priceTo,
            label: `${props.priceLabel || 'Cena'}: do ${formatNumber(priceTo)} Kč`,
        })
    }

    // Mileage filter
    const defaultMileageFrom = 0
    // Round maxMileage up to nearest 10k with minimum 300k
    const defaultMileageTo = Math.max(300000, Math.ceil(maxMileage.value / 10000) * 10000)

    // Add mileage from filter badge if value is not null and different from default
    if (filters.mileageFrom !== null && filters.mileageFrom !== defaultMileageFrom) {
        items.push({
            filterName: 'mileageFrom',
            filterValue: filters.mileageFrom,
            label: `${props.mileageLabel || 'Nájezd'}: od ${formatNumber(filters.mileageFrom)} km`,
        })
    }

    // Add mileage to filter badge if value is not null and different from default
    // Always show the mileage to badge when mileage from is set
    if ((filters.mileageTo !== null && filters.mileageTo !== defaultMileageTo) ||
        (filters.mileageFrom !== null && filters.mileageFrom !== defaultMileageFrom)) {
        const mileageTo = filters.mileageTo !== null ? filters.mileageTo : defaultMileageTo;
        items.push({
            filterName: 'mileageTo',
            filterValue: mileageTo,
            label: `${props.mileageLabel || 'Nájezd'}: do ${formatNumber(mileageTo)} km`,
        })
    }

    // Age filter
    const currentYear = new Date().getFullYear()
    const defaultAgeFrom = 1990
    const defaultAgeTo = currentYear

    // Add age from filter badge if value is not null and different from default
    if (filters.ageFrom !== null && filters.ageFrom !== defaultAgeFrom) {
        items.push({
            filterName: 'ageFrom',
            filterValue: filters.ageFrom,
            label: `${props.ageLabel || 'Stáří'}: od ${filters.ageFrom}`,
        })
    }

    // Add age to filter badge if value is not null and different from default
    // Always show the age to badge when age from is set
    if ((filters.ageTo !== null && filters.ageTo !== defaultAgeTo) ||
        (filters.ageFrom !== null && filters.ageFrom !== defaultAgeFrom)) {
        const ageTo = filters.ageTo !== null ? filters.ageTo : defaultAgeTo;
        items.push({
            filterName: 'ageTo',
            filterValue: ageTo,
            label: `${props.ageLabel || 'Stáří'}: do ${ageTo}`,
        })
    }

    // Additional Attributes
    if (options.value.additionalAttributes && options.value.additionalAttributes.length) {
        options.value.additionalAttributes.forEach(attribute => {
            // For boolean attributes
            if (attribute.type === 'boolean' && filters.additionalAttributes[attribute.id] === true) {
                items.push({
                    filterName: 'additionalAttributes',
                    filterValue: attribute.id,
                    label: attribute.name,
                })
            }

            // For array attributes with options
            if (attribute.type === 'array' && attribute.options &&
                Array.isArray(filters.additionalAttributes[attribute.id]) &&
                filters.additionalAttributes[attribute.id].length) {

                // Find selected options and add them as badges
                attribute.options.forEach(option => {
                    if (filters.additionalAttributes[attribute.id].includes(option.id)) {
                        items.push({
                            filterName: 'additionalAttributes',
                            filterValue: attribute.id,
                            optionId: option.id,
                            label: `${attribute.name}: ${option.name}`,
                        })
                    }
                })
            }
        })
    }

    // Custom Tags
    if (options.value.customTags && options.value.customTags.length && filters.customTags.length) {
        options.value.customTags.forEach(tag => {
            const selectedValue = filters.customTags.find(
                selected => selected === tag.id || selected === tag.id.toString()
            )

            if (selectedValue !== undefined) {
                items.push({
                    filterName: 'customTags',
                    filterValue: selectedValue,
                    label: tag.title,
                })
            }
        })
    }

    // Volvo Selekt only
    if (filters.volvoSelektOnly) {
        items.push({
            filterName: 'volvoSelektOnly',
            filterValue: true,
            label: props.badgeVolvoSelekt,
        })
    }
    if (filters.tipcarsApprovedOnly) {
        items.push({
            filterName: 'tipcarsApprovedOnly',
            filterValue: true,
            label: props.badgeTipcarsApproved || 'Approved',
        })
    }

    // VAT deductible only
    if (filters.vatDeductibleOnly) {
        items.push({
            filterName: 'vatDeductibleOnly',
            filterValue: true,
            label: props.badgeVatDeductible,
        })
    }

    // Is in stock
    if (filters.isInStock) {
        items.push({
            filterName: 'isInStock',
            filterValue: true,
            label: props.badgeInStock,
        })
    }

    return items
})

// Format number helper
function formatNumber(n) {
    return new Intl.NumberFormat('cs-CZ').format(n)
}

// Update filters from sidebar
function updateFilters(newFilters) {
    Object.assign(filters, newFilters)
}

// Mobile filter functions
function openMobileFilter() {
    isMobileFilterOpen.value = true
    // Store filter state in localStorage
    localStorage.setItem('filterOpen', 'true')
    // Add filter-active class to body for proper floating behavior
    document.body.classList.add('filter-active')
}

function closeMobileFilter() {
    isMobileFilterOpen.value = false
    // Store filter state in localStorage
    localStorage.setItem('filterOpen', 'false')
    // Remove filter-active class from body
    document.body.classList.remove('filter-active')
}

// Handle click on filter__controls-wrapper
function handleFilterControlsClick(event) {
    // Only process if the filter is open on mobile
    if (!isMobileFilterOpen.value) return

    // Check if the click is outside the filter__controls-container
    const container = event.currentTarget.querySelector('.filter__controls-container')
    if (container && !container.contains(event.target)) {
        // If the click is on the backdrop or outside the container, close the filter
        closeMobileFilter()
    }
}

// Load options
async function loadOptions() {
    loading.value = true
    try {
        const {
          options: opts,
          present,
          histogram,
          maxMileage: mm,
          maxAge: ma
        } = (await axios.get('/api/v1/car-filter/options')).data

        options.value = opts

        histogramData.value = histogram;

        maxMileage.value = mm
        maxAge.value     = ma

        // Initialize range filters after maxAge is set
        initRangeFilters()

        applyPresentData(present)
    } finally {
        loading.value = false
    }
}

// Build API params
function buildParams(page = 1, forUrl = false, isLoadMoreButton = false) {
    const params = { page }
    if (filters.brands.length)               params.filterBrands               = filters.brands
    if (filters.availabilityTypes.length)    params.filterAvailabilityTypes    = filters.availabilityTypes
    if (filters.showrooms.length)            params.filterShowrooms            = filters.showrooms
    if (filters.models.length)               params.filterModels               = filters.models
    if (filters.fuelTypes.length)            params.filterFuelTypes            = filters.fuelTypes
    if (filters.transmissionTypes.length)    params.filterTransmissionTypes    = filters.transmissionTypes
    if (filters.bodyTypes.length)            params.filterBodyTypes            = filters.bodyTypes
    if (filters.bodyColors.length)           params.filterBodyColors           = filters.bodyColors
    if (filters.categories.length)           params.filterCategories           = filters.categories

    // Handle display type
    if (listDisplayType.value) {
        if (forUrl) {
            params['display-list'] = true
        } else {
            params.displayList = true
        }
    } else {
        // Explicitly handle false case to ensure URL parameter is removed
        if (forUrl) {
            params['display-list'] = false
        } else {
            params.displayList = false
        }
    }

    // Handle lazy loading
    // Only include lazy-prev-pages parameter when using the "Load More" button
    if (lazyPrevPages.value > 0 && isLoadMoreButton) {
        if (forUrl) {
            params['lazy-prev-pages'] = lazyPrevPages.value
        } else {
            params.lazyPrevPages = lazyPrevPages.value
        }
    }

    // For URL parameters, use p instead of page for pages > 1
    // For page 1, don't include any page parameter
    if (forUrl) {
        // Use currentPage.value instead of page parameter to ensure consistency
        // This ensures the page parameter persists in the URL even when filters change
        const pageToUse = currentPage.value || page
        if (pageToUse > 1) {
            params.p = pageToUse
        }
        delete params.page
    }

    // Price filter params
    const defaultPriceFrom = histogramData.value.min
    const defaultPriceTo = histogramData.value.max
    const isFullDefaultPriceRange =
        selectedPriceRange.value === '-' &&
        defaultPriceTo != null &&
        filters.priceTo === defaultPriceTo &&
        (
            (filters.priceFrom != null && filters.priceFrom === defaultPriceFrom) ||
            (filters.priceFrom != null && filters.priceFrom === 0) ||
            filters.priceFrom == null
        )
    const hasCustomPriceFrom =
        filters.priceFrom != null &&
        filters.priceFrom !== defaultPriceFrom &&
        !(filters.priceFrom === 0 && filters.priceTo === defaultPriceTo)
    const hasCustomPriceTo =
        filters.priceTo != null &&
        filters.priceTo !== defaultPriceTo &&
        !isFullDefaultPriceRange

    // For URL parameters, if either price parameter is set, include both
    if (forUrl) {
        if (hasCustomPriceFrom && hasCustomPriceTo) {
            params['pr-min'] = filters.priceFrom
            params['pr-max'] = filters.priceTo
        } else if (hasCustomPriceFrom) {
            // only lower bound selected → keep explicit min, cap with current max
            params['pr-min'] = filters.priceFrom
            params['pr-max'] = defaultPriceTo
        } else if (hasCustomPriceTo) {
            // only upper bound selected → encode as 0-max to match radio shortcuts
            params['pr-min'] = 0
            params['pr-max'] = filters.priceTo
        }
    } else {
        // For API calls, include any explicitly set price bounds
        if (filters.priceFrom != null) {
            params.filterPriceFrom = filters.priceFrom
        }
        if (filters.priceTo != null) {
            params.filterPriceTo = filters.priceTo
        }
    }

    // Only include mileage filter params if they're not default values
    const defaultMileageFrom = 0 // Default value from CarFilterSidebar.vue
    // Round maxMileage up to nearest 10k with minimum 300k
    const defaultMileageTo = Math.max(300000, Math.ceil(maxMileage.value / 10000) * 10000)

    // For URL parameters, if either mileage parameter is set, include both
    if (forUrl) {
        if (filters.mileageFrom != null && filters.mileageFrom !== defaultMileageFrom) {
            params['mi-min'] = filters.mileageFrom
            // Always include mi-max when mi-min is set
            params['mi-max'] = filters.mileageTo != null ? filters.mileageTo : defaultMileageTo
        } else if (filters.mileageTo != null && filters.mileageTo !== defaultMileageTo) {
            // Always include mi-min when mi-max is set
            params['mi-min'] = filters.mileageFrom != null ? filters.mileageFrom : defaultMileageFrom
            params['mi-max'] = filters.mileageTo
        }
    } else {
        // For API calls, keep the original behavior
        if (filters.mileageFrom != null) {
            params.filterMileageFrom = filters.mileageFrom
        }
        if (filters.mileageTo != null) {
            params.filterMileageTo = filters.mileageTo
        }
    }

    // Only include age filter params if they're not default values
    const currentYear = new Date().getFullYear()
    const defaultAgeFrom = 1990 // minYear from CarFilterSidebar.vue
    const defaultAgeTo = currentYear

    // For URL parameters, handle age parameters
    if (forUrl) {
        if (filters.ageFrom != null && filters.ageFrom !== defaultAgeFrom) {
            params['ag-min'] = filters.ageFrom
            // Always include ag-max when ag-min is set
            params['ag-max'] = filters.ageTo != null ? filters.ageTo : defaultAgeTo
        } else if (filters.ageTo != null && filters.ageTo !== defaultAgeTo) {
            // Only include ag-max when only ageTo is set (to match Livewire behavior)
            params['ag-max'] = filters.ageTo
        }
    } else {
        // For API parameters, convert year of manufacture to years from current year
        if (filters.ageFrom != null) {
            // If ageFrom is 2017, we want cars from 2017 or later, which means cars that are at most (currentYear - 2017) years old
            params.filterAgeTo = currentYear - filters.ageFrom
        }
        if (filters.ageTo != null) {
            // If ageTo is 2019, we want cars from 2019 or earlier, which means cars that are at least (currentYear - 2019) years old
            params.filterAgeFrom = currentYear - filters.ageTo
        }
    }

    if (filters.vatDeductibleOnly)           params.filterVatDeductibleOnly    = true
    if (filters.volvoSelektOnly)             params.filterVolvoSelektOnly      = true
    if (filters.tipcarsApprovedOnly)         params.filterTipcarsApprovedOnly  = true
    if (filters.isInStock)                   params.filterIsInStock            = true
    if (filters.customTags.length)           params.filterCustomTags           = filters.customTags
    if (Object.keys(filters.additionalAttributes).length) {
        // Format additional attributes as aa[id]=true or aa[id]=optionId
        params.filterAdditionalAttributes = {}
        for (const [attributeId, value] of Object.entries(filters.additionalAttributes)) {
            if (typeof value === 'boolean') {
                // For boolean attributes
                params.filterAdditionalAttributes[attributeId] = value
            } else if (Array.isArray(value)) {
                // For array attributes with options
                value.forEach(optionId => {
                    params.filterAdditionalAttributes[attributeId] = optionId
                })
            } else if (value !== null && value !== undefined) {
                // For other types (like single option selection)
                params.filterAdditionalAttributes[attributeId] = value
            }
        }
    }
    if (sort.value && sort.value !== 'newest') params.sort = sort.value
    return params
}

// Fetch results
async function fetchResults(page = 1, isLoadMoreButton = false, skipUrlUpdate = false) {
    loading.value = true
    try {
        const params = buildParams(page, false, isLoadMoreButton)
        const res = await axios.get('/api/v1/car-filter/results', { params })

        // If using the "Load More" button, append results
        // Otherwise (direct page navigation), replace results
        const isLoadingMore = isLoadMoreButton
        offers.value = isLoadingMore ? [...offers.value, ...res.data.data] : res.data.data
        if (Array.isArray(res.data.data)) {
            rememberOffersForComparison(res.data.data)
        }

        total.value         = res.data.total
        totalNoFilter.value = res.data.totalNoFilter
        currentPage.value   = res.data.currentPage
        lastPage.value      = res.data.lastPage

        // Update URL parameters only if not skipped
        if (!skipUrlUpdate && !urlUpdatedByWatch.value) {
            if (isLoadingMore) {
                // When loading more, increment lazyPrevPages and update URL
                lazyPrevPages.value++
                const urlParams = buildParams(page, true, isLoadMoreButton)
                await updateUrlWithRedirect(urlParams)
            } else if (page > 1) {
                // For direct page navigation, reset lazyPrevPages and update URL
                lazyPrevPages.value = 0
                const urlParams = buildParams(page, true, isLoadMoreButton)
                await updateUrlWithRedirect(urlParams)
            } else {
                // For page 1, reset lazyPrevPages
                lazyPrevPages.value = 0
                // Update URL to remove any page or lazyPrevPages parameters
                const urlParams = buildParams(1, true, isLoadMoreButton)
                await updateUrlWithRedirect(urlParams)
            }
        }

        applyPresentData(res.data.present)

        // Update metadata from the response
        breadcrumbs.value = res.data.breadcrumbs
        pageTitle.value   = res.data.pageTitle
        if (!isInitialLoad.value) {
            seoTitle.value    = res.data.seoTitle || res.data.pageTitle
            document.title    = seoTitle.value + props.titleSuffix
            metaDescription.value = res.data.metaDescription || res.data.pageTitle
            updateMetaDescription(metaDescription.value)
            updateSocialTags(seoTitle.value, metaDescription.value)
        }
        if (!isInitialLoad.value && res.data.metaRobots) {
            updateMetaRobots(res.data.metaRobots)
        }
        modelSeriesChips.value = res.data.modelSeriesChips
        seoHeadline.value = res.data.seoHeadline || ''
        seoDescription.value = res.data.seoDescription || ''
        siteId.value      = res.data.siteId
        lang.value        = res.data.lang

        // Generate and dispatch data layer payload
        dispatchDataLayerEvent(offers.value)

        // Update structured data (JSON-LD)
        updateStructuredData(offers.value)
    } finally {
        loading.value = false
    }
}

// Update URL redirect from backend
async function updateUrlWithRedirect(params) {
    // 1) Získej z backendu „čistou“ URI a seznam query parametrů
    const { data } = await axios.get('/api/v1/car-filter/url', { params });
    let newUrl = data.uri;
    const parts = [];

    // 2) Přidej všechny filtry vrácené z data.query
    if (data.query && Object.keys(data.query).length) {
        for (const [key, value] of Object.entries(data.query)) {
            if (key === 'page') {
                // backend stránkování řešíme zvlášť níže
                continue;
            }

            // další objekty (např. aa[attr]=…)
            if (key === 'aa' && typeof value === 'object' && !Array.isArray(value)) {
                for (const [attrId, attrVal] of Object.entries(value)) {
                    parts.push(`aa[${encodeURIComponent(attrId)}]=${encodeURIComponent(attrVal)}`);
                }
            }
            // pole
            else if (Array.isArray(value)) {
                value.forEach((v, i) => {
                    parts.push(`${encodeURIComponent(key)}[${i}]=${encodeURIComponent(v)}`);
                });
            }
            // objekt (jiné než aa)
            else if (typeof value === 'object' && value !== null) {
                for (const [subKey, subVal] of Object.entries(value)) {
                    parts.push(`${encodeURIComponent(key)}[${encodeURIComponent(subKey)}]=${encodeURIComponent(subVal)}`);
                }
            }
            // jednoduchý pár key=value
            else {
                parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
            }
        }

        // pokud si backend vrátil číslo stránky větší než 1, přidej ho sem
        if (data.query.page > 1) {
            parts.push(`p=${encodeURIComponent(data.query.page)}`);
        }
    }

    // 3) **VŽDY** přidej paginaci z lokálních params
    if (params.p != null) {
        parts.push(`p=${encodeURIComponent(params.p)}`);
    }
    if (params['lazy-prev-pages'] != null) {
        parts.push(`lazy-prev-pages=${encodeURIComponent(params['lazy-prev-pages'])}`);
    }

    // 4) Sestav finální URL s query stringem
    if (parts.length > 0) {
        newUrl += `?${parts.join('&')}`;
    }

    // 5) A pushni do historie
    window.history.pushState(
        { filters: JSON.parse(JSON.stringify(params)) },
        '',
        newUrl
    );

    // 6) Aktualizuj og:url, canonical a hreflang
    const absoluteUrl = window.location.origin + newUrl
    updateUrlTags(absoluteUrl)
    updateHreflangTags(data.hreflang)
}

// Meta description update
function updateMetaDescription(desc) {
    const el = document.querySelector("meta[name='description']")
    if (el) el.setAttribute('content', desc)
}

// Meta robots update
function updateMetaRobots(robots) {
    const el = document.querySelector("meta[name='robots']")
    if (el) el.setAttribute('content', robots)
}

// Social meta tags update
function updateSocialTags(title, description) {
    const ogTitle = document.querySelector("meta[property='og:title']")
    if (ogTitle) ogTitle.setAttribute('content', title)

    const ogDesc = document.querySelector("meta[property='og:description']")
    if (ogDesc) ogDesc.setAttribute('content', description)

    const twTitle = document.querySelector("meta[name='twitter:title']")
    if (twTitle) twTitle.setAttribute('content', title)

    const twDesc = document.querySelector("meta[name='twitter:description']")
    if (twDesc) twDesc.setAttribute('content', description)
}

// og:url + canonical update
function updateUrlTags(url) {
    const ogUrl = document.querySelector("meta[property='og:url']")
    if (ogUrl) ogUrl.setAttribute('content', url)

    const canonical = document.querySelector("link[rel='canonical']")
    if (canonical) canonical.setAttribute('href', url)
}

// hreflang update — uses data returned by the URL API
// Updates both SEO <link rel="alternate"> tags and navigation <a hreflang> language switcher links
function updateHreflangTags(hreflangData) {
    if (!hreflangData || !hreflangData.length) return
    const scheme = window.location.protocol + '//'
    const queryString = window.location.search
    hreflangData.forEach(({ hreflang, domain, uri }) => {
        const fullUrl = scheme + domain + uri + queryString
        document.querySelectorAll(`[hreflang='${hreflang}']`).forEach(el => {
            el.setAttribute('href', fullUrl)
        })
    })
}

// Format range helper
function formatRange(range, translations) {
    if (range === '-') {
        return translations.all
    }
    const num = Number(range.replace(/\D/g, ''))
    if (range.startsWith('-')) {
        return translations.lessThan.replace('{value}', formatNumber(num))
    }
    if (range.endsWith('-')) {
        return translations.moreThan.replace('{value}', formatNumber(num))
    }
    const [low, high] = range.split('-').map(Number)
    return `${formatNumber(low)} – ${formatNumber(high)}`
}

// Listen to popstate
window.addEventListener('popstate', async event => {
    const state = event.state
    if (!state || !state.filters) return
    const f = state.filters
    filters.brands               = f.filterBrands || []
    filters.availabilityTypes    = f.filterAvailabilityTypes || []
    filters.showrooms            = f.filterShowrooms || []
    filters.models               = f.filterModels || []
    filters.fuelTypes            = f.filterFuelTypes || []
    filters.transmissionTypes    = f.filterTransmissionTypes || []
    filters.bodyTypes            = f.filterBodyTypes || []
    filters.bodyColors           = f.filterBodyColors || []
    filters.categories           = f.filterCategories || []
    filters.priceFrom            = f.filterPriceFrom ?? null
    filters.priceTo              = f.filterPriceTo ?? null
    filters.mileageFrom          = f.filterMileageFrom ?? null
    filters.mileageTo            = f.filterMileageTo ?? null
    filters.ageFrom              = f.filterAgeFrom ?? null
    filters.ageTo                = f.filterAgeTo ?? null
    filters.vatDeductibleOnly    = !!f.filterVatDeductibleOnly
    filters.volvoSelektOnly      = !!f.filterVolvoSelektOnly
    filters.tipcarsApprovedOnly  = !!f.filterTipcarsApprovedOnly
    filters.isInStock            = !!f.filterIsInStock
    filters.additionalAttributes = f.filterAdditionalAttributes || {}
    filters.customTags           = f.filterCustomTags || []
    sort.value                   = f.sort || 'newest'
    listDisplayType.value        = !!f.displayList
    lazyPrevPages.value          = f.lazyPrevPages || 0

    // Check authentication status first
    await checkAuthStatus()

    // Fetch latest favorites and comparison data
    await fetchComparedCars()
    await fetchFavoriteCars()

    // Fetch results (which now includes metadata)
    await fetchResults(f.page || 1, false)
})

// Flag to indicate that URL has been updated by the watch function
const urlUpdatedByWatch = ref(false)
const shouldRefreshResultsAfterBfcacheRestore = ref(false)

// Watch filters and sort
watch([
    () => filters.brands,
    () => filters.availabilityTypes,
    () => filters.showrooms,
    () => filters.models,
    () => filters.fuelTypes,
    () => filters.transmissionTypes,
    () => filters.bodyTypes,
    () => filters.bodyColors,
    () => filters.categories,
    () => filters.priceFrom,
    () => filters.priceTo,
    () => filters.mileageFrom,
    () => filters.mileageTo,
    () => filters.ageFrom,
    () => filters.ageTo,
    () => filters.vatDeductibleOnly,
    () => filters.volvoSelektOnly,
    () => filters.tipcarsApprovedOnly,
    () => filters.isInStock,
    () => JSON.stringify(filters.additionalAttributes),
    () => filters.customTags,
    () => sort.value,
    () => listDisplayType.value,
], async () => {
    if (isInitialLoad.value) return

    // Reset to page 1 when filters change
    currentPage.value = 1
    offers.value = [] // Clear existing offers

    // Check authentication status first
    await checkAuthStatus()

    const params = buildParams(1, true, false)

    // Set the flag to indicate that URL has been updated by the watch function
    urlUpdatedByWatch.value = true
    await updateUrlWithRedirect(params)

    // Call fetchResults with the skipUrlUpdate parameter set to true
    // This will also update metadata
    await fetchResults(1, false, true)

    // Reset the flag after fetchResults completes
    urlUpdatedByWatch.value = false

    // Update banner slides when filters change (client-side filtering)
    filterBannerSlides()
}, { deep: true })

// Watch selected ranges
watch(selectedMileageRange, range => {
    if (range === '-') { filters.mileageFrom = null; filters.mileageTo = null }
    else if (range.startsWith('-')) { filters.mileageFrom = null; filters.mileageTo = Number(range.slice(1)) }
    else if (range.endsWith('-')) { filters.mileageFrom = Number(range.slice(0, -1)); filters.mileageTo = null }
    else { const [low, high] = range.split('-').map(Number); filters.mileageFrom = low; filters.mileageTo = high }
})
watch(selectedAgeRange, range => {
    if (range === '-') { filters.ageFrom = null; filters.ageTo = null }
    else if (range.startsWith('-')) { filters.ageFrom = null; filters.ageTo = Number(range.slice(1)) }
    else if (range.endsWith('-')) { filters.ageFrom = Number(range.slice(0, -1)); filters.ageTo = null }
    else { const [low, high] = range.split('-').map(Number); filters.ageFrom = low; filters.ageTo = high }
})
watch(selectedPriceRange, range => {
    if (isSyncingSelectedPriceRange.value) {
        return
    }

    if (range === '-') { filters.priceFrom = null; filters.priceTo = null }
    else if (range.startsWith('-')) { filters.priceFrom = null; filters.priceTo = Number(range.slice(1)) }
    else if (range.endsWith('-')) { filters.priceFrom = Number(range.slice(0, -1)); filters.priceTo = null }
    else { const [low, high] = range.split('-').map(Number); filters.priceFrom = low; filters.priceTo = high }
})

// Keep radio selection in sync when user moves slider
watch([
    () => filters.priceFrom,
    () => filters.priceTo,
    () => histogramData.value?.min,
    () => JSON.stringify(presentPriceRanges.value),
], ([pf, pt, histMin]) => {
    // Determine the radio key that should be active
    let next = '-'
    const pfNum = pf != null ? Number(pf) : null
    const ptNum = pt != null ? Number(pt) : null
    const leftOk = pfNum === null || pfNum === 0 || (histMin != null && pfNum === Number(histMin))
    const upperBoundRangeKey = getUpperBoundPriceRangeKey(ptNum)
    if (leftOk && upperBoundRangeKey) {
        next = upperBoundRangeKey
    }

    if (selectedPriceRange.value !== next) {
        isSyncingSelectedPriceRange.value = true
        selectedPriceRange.value = next
        nextTick(() => {
            isSyncingSelectedPriceRange.value = false
        })
    }
})

function activateHydratedUi() {
    isHydrated.value = true
    document.querySelectorAll('[data-server-results-fallback]').forEach(element => {
        element.remove()
    })
    document.querySelectorAll('[data-server-filter-links-fallback]').forEach(element => {
        element.remove()
    })
}

// Mounted
onMounted(async () => {
    // Remove server-rendered SEO fallback elements after Vue mounts
    document.querySelectorAll('[data-seo-fallback]').forEach(element => {
        element.remove()
    })

    // Restore filter state from localStorage
    const isFilterOpen = localStorage.getItem('filterOpen')
    if (isFilterOpen === 'true') {
        isMobileFilterOpen.value = true
        // Also add the filter-active class to the body
        document.body.classList.add('filter-active')
    }

    const urlParams = new URLSearchParams(window.location.search)
    // Check both alias (pr-min/pr-max) and full parameter names
    const pf = getSingle('pr-min') ?? getSingle('filterPriceFrom')
    const pt = getSingle('pr-max') ?? getSingle('filterPriceTo')
    if (pf !== null) filters.priceFrom = Number(pf)
    if (pt !== null) filters.priceTo   = Number(pt)

    // Preselect price radio only for known shortcuts; otherwise keep 'all'
    if (pf !== null || pt !== null) {
        const pfNum = pf !== null ? Number(pf) : null
        const ptNum = pt !== null ? Number(pt) : null
        const upperBoundRangeKey = pfNum === 0 ? getUpperBoundPriceRangeKey(ptNum) : null
        if (upperBoundRangeKey) {
            selectedPriceRange.value = upperBoundRangeKey
        } else {
            selectedPriceRange.value = '-'
        }
    }

    // Handle display list parameter
    const displayList = getSingle('listDisplayType')
    if (displayList !== null) listDisplayType.value = displayList === 'true' || displayList === '1'

    // Handle page parameter
    const pageParam = getSingle('page')
    if (pageParam !== null) currentPage.value = Number(pageParam)

    // Handle lazy-prev-pages parameter
    const lazyPrevPagesParam = getSingle('numberOfPreviousPagesShown')
    if (lazyPrevPagesParam !== null) lazyPrevPages.value = Number(lazyPrevPagesParam)

    // Handle age filter parameters with aliases
    const af = getSingle('ag-min') ?? getSingle('filterAgeFrom')
    const at = getSingle('ag-max') ?? getSingle('filterAgeTo')
    if (af !== null) filters.ageFrom = Number(af)
    if (at !== null) filters.ageTo   = Number(at)

    // Handle mileage filter parameters with aliases
    const mf = getSingle('mi-min') ?? getSingle('filterMileageFrom')
    const mt = getSingle('mi-max') ?? getSingle('filterMileageTo')
    if (mf !== null) filters.mileageFrom = Number(mf)
    if (mt !== null) filters.mileageTo   = Number(mt)

    const vatParam = parseBooleanQueryParam(getSingle('filterVatDeductibleOnly'))
    if (vatParam !== null) {
        filters.vatDeductibleOnly = vatParam
    }

    const volvoParam = parseBooleanQueryParam(getSingle('volvo-selekt') ?? getSingle('filterVolvoSelektOnly'))
    if (volvoParam !== null) {
        filters.volvoSelektOnly = volvoParam
    }
    const approvedParam = parseBooleanQueryParam(getSingle('approved') ?? getSingle('filterTipcarsApprovedOnly'))
    if (approvedParam !== null) {
        filters.tipcarsApprovedOnly = approvedParam
    }

    const inStockParam = parseBooleanQueryParam(getSingle('in-stock') ?? getSingle('filterIsInStock'))
    if (inStockParam !== null) {
        filters.isInStock = inStockParam
    }

    // 1) Check authentication status
    await checkAuthStatus()

    // 2) Fetch compared cars and favorites
    await fetchComparedCars()
    await fetchFavoriteCars()

    // 3) Načti seznam možností a present‐county
    await loadOptions()

    // Set selected ranges based on URL parameters
    // This needs to be done after loadOptions() because it depends on maxMileage and maxAge
    if (mf !== null || mt !== null) {
        // Special case: if min is 0 and max is 50000, use "-50000" format for the radio button
        if (mf === "0" && mt === "50000" || (Number(mf) === 0 && Number(mt) === 50000)) {
            selectedMileageRange.value = `-${mt}`;
        }
        // If both min and max are set
        else if (mf !== null && mt !== null) {
            selectedMileageRange.value = `${mf}-${mt}`;
        }
        // If only min is set
        else if (mf !== null) {
            selectedMileageRange.value = `${mf}-`;
        }
        // If only max is set
        else if (mt !== null) {
            selectedMileageRange.value = `-${mt}`;
        }
    } else {
        // Explicitly set the default value if no URL parameters are present
        selectedMileageRange.value = '-';
    }

    if (af !== null || at !== null) {
        // Special case: if min is current year minus 3 and max is current year, use "-3" format for the radio button
        const currentYear = new Date().getFullYear();
        if (af === String(currentYear - 3) && at === String(currentYear) ||
            (Number(af) === currentYear - 3 && Number(at) === currentYear)) {
            selectedAgeRange.value = `-3`;
        }
        // Special case: if min is current year minus 5 and max is current year, use "-5" format for the radio button
        else if (af === String(currentYear - 5) && at === String(currentYear) ||
                (Number(af) === currentYear - 5 && Number(at) === currentYear)) {
            selectedAgeRange.value = `-5`;
        }
        // If both min and max are set
        else if (af !== null && at !== null) {
            selectedAgeRange.value = `${af}-${at}`;
        }
        // If only min is set
        else if (af !== null) {
            selectedAgeRange.value = `${af}-`;
        }
        // If only max is set
        else if (at !== null) {
            // Special case: if only max is set to 3 or 5, use the predefined radio button values
            if (at === "3" || Number(at) === 3) {
                selectedAgeRange.value = `-3`;
            } else if (at === "5" || Number(at) === 5) {
                selectedAgeRange.value = `-5`;
            } else {
                selectedAgeRange.value = `-${at}`;
            }
        }
    } else {
        // Explicitly set the default value if no URL parameters are present
        selectedAgeRange.value = '-';
    }

    // Handle price range selection based on URL parameters
    const priceFromUrl = getSingle('pr-min') ?? getSingle('filterPriceFrom')
    const priceToUrl = getSingle('pr-max') ?? getSingle('filterPriceTo')

    if (priceFromUrl !== null || priceToUrl !== null) {
        const pfNum = priceFromUrl !== null ? Number(priceFromUrl) : null
        const ptNum = priceToUrl !== null ? Number(priceToUrl) : null

        const minBoundary = histogramData.value?.min ?? 0
        const upperBoundRangeKey = getUpperBoundPriceRangeKey(ptNum)

        // "do X" case: accept both 0 and histogram min as left boundary
        if ((pfNum === 0 || pfNum === minBoundary) && upperBoundRangeKey) {
            selectedPriceRange.value = upperBoundRangeKey;
        }
        // Other combinations
        else if (pfNum !== null && ptNum !== null) {
            // custom range not represented by radios → default to 'all'
            selectedPriceRange.value = '-';
        } else if (pfNum !== null) {
            // only lower bound has no dedicated radio → default to 'all'
            selectedPriceRange.value = '-';
        } else if (ptNum !== null) {
            selectedPriceRange.value = `-${ptNum}`;
        }
    } else {
        // Explicitly set the default value if no URL parameters are present
        selectedPriceRange.value = '-';
    }

    function collectArray(fullKey) {
        const result = []

        // Define alias mapping based on QueryStringConfigService
        const aliasMap = {
            'filterBodyColors': 'bc',
            'filterShowrooms': 'showrooms',
            'filterTransmissionTypes': 'tt',
            'filterAgeFrom': 'ag-min',
            'filterAgeTo': 'ag-max',
            'filterMileageFrom': 'mi-min',
            'filterMileageTo': 'mi-max',
            'filterPriceFrom': 'pr-min',
            'filterPriceTo': 'pr-max',
            'listDisplayType': 'display-list',
            'filterVatDeductibleOnly': 'vat',
            'filterVolvoSelektOnly': 'volvo-selekt',
            'filterIsInStock': 'in-stock',
            'filterExtendedWarrantyOnly': 'ew',
            'filterAdditionalAttributes': 'aa',
            'filterCustomTags': 'ct',
            'page': 'p',
            'numberOfPreviousPagesShown': 'lazy-prev-pages'
        }

        const alias = aliasMap[fullKey] || fullKey

        for (const [key, value] of urlParams.entries()) {
            // Check both full key and alias variants
            if (key === fullKey || key.startsWith(`${fullKey}[`) ||
                key === alias || key.startsWith(`${alias}[`)) {
                result.push(Number(value))
            }
        }
        return result
    }
    function getSingle(fullKey) {
        // Define alias mapping (same as above)
        const aliasMap = {
            'filterBodyColors': 'bc',
            'filterShowrooms': 'showrooms',
            'filterTransmissionTypes': 'tt',
            'filterAgeFrom': 'ag-min',
            'filterAgeTo': 'ag-max',
            'filterMileageFrom': 'mi-min',
            'filterMileageTo': 'mi-max',
            'filterPriceFrom': 'pr-min',
            'filterPriceTo': 'pr-max',
            'listDisplayType': 'display-list',
            'filterVatDeductibleOnly': 'vat',
            'filterVolvoSelektOnly': 'volvo-selekt',
            'filterIsInStock': 'in-stock',
            'filterExtendedWarrantyOnly': 'ew',
            'filterAdditionalAttributes': 'aa',
            'filterCustomTags': 'ct',
            'page': 'p',
            'numberOfPreviousPagesShown': 'lazy-prev-pages',
            'sort': 'sort'
        }

        const alias = aliasMap[fullKey] || fullKey

        // Check alias first, then full key
        return urlParams.get(alias) || urlParams.get(fullKey) || null
    }

    filters.brands            = collectArray('filterBrands')
    filters.availabilityTypes = collectArray('filterAvailabilityTypes')
    filters.showrooms         = collectArray('filterShowrooms')
    filters.models            = collectArray('filterModels')
    filters.fuelTypes         = collectArray('filterFuelTypes')
    filters.transmissionTypes = collectArray('filterTransmissionTypes')
    filters.bodyTypes         = collectArray('filterBodyTypes')
    filters.bodyColors        = collectArray('filterBodyColors')
    filters.categories        = collectArray('filterCategories')
    filters.customTags        = collectArray('filterCustomTags')

    // Handle additional attributes (aa parameter)
    const additionalAttrs = {}
    for (const [key, value] of urlParams.entries()) {
        // Match parameters like aa[123] or filterAdditionalAttributes[123]
        const aaMatch = key.match(/^(aa|filterAdditionalAttributes)\[(\d+)\]$/)
        if (aaMatch) {
            const attributeId = aaMatch[2]
            // Convert to boolean if value is 'true' or '1', otherwise keep as is (could be option ID)
            if (value === 'true' || value === '1') {
                additionalAttrs[attributeId] = true
            } else if (!isNaN(Number(value))) {
                additionalAttrs[attributeId] = Number(value)
            } else {
                additionalAttrs[attributeId] = value
            }
        }
    }
    filters.additionalAttributes = additionalAttrs

    // Set selected range values based on the filter values
    if (filters.mileageFrom !== null || filters.mileageTo !== null) {
        // Special case: if min is 0 and max is 50000, use "-50000" format for the radio button
        if (filters.mileageFrom === 0 && filters.mileageTo === 50000) {
            selectedMileageRange.value = `-${filters.mileageTo}`
        }
        // Create a range string based on the filter values
        else if (filters.mileageFrom === null) {
            selectedMileageRange.value = `-${filters.mileageTo}`
        } else if (filters.mileageTo === null) {
            selectedMileageRange.value = `${filters.mileageFrom}-`
        } else {
            selectedMileageRange.value = `${filters.mileageFrom}-${filters.mileageTo}`
        }
    }

    if (filters.ageFrom !== null || filters.ageTo !== null) {
        // Special cases for age ranges
        const currentYear = new Date().getFullYear();
        if (filters.ageFrom === currentYear - 3 && filters.ageTo === currentYear) {
            selectedAgeRange.value = `-3`
        } else if (filters.ageFrom === currentYear - 5 && filters.ageTo === currentYear) {
            selectedAgeRange.value = `-5`
        }
        // Create a range string based on the filter values
        else if (filters.ageFrom === null) {
            selectedAgeRange.value = `-${filters.ageTo}`
        } else if (filters.ageTo === null) {
            selectedAgeRange.value = `${filters.ageFrom}-`
        } else {
            selectedAgeRange.value = `${filters.ageFrom}-${filters.ageTo}`
        }
    }


    const sortParam = getSingle('sort')
    if (sortParam) sort.value = sortParam

    // 3) Naplň filtry podle slugů v URL path (např. /nove-vozy/es90-1)
    const segments = window.location.pathname.replace(/^\/|\/$/g, '').split('/')

    // Check for special marketing URLs
    if (segments[0] === 'volvo-selekt') {
        filters.volvoSelektOnly = true
    } else if (segments[0] === 'skladem') {
        filters.isInStock = true

        // Handle model or body type if present
        if (segments[1]) {
            // Check if it's a model
            const md = options.value.models.find(x => x.slug === segments[1])
            if (md) {
                filters.models = [md.id]
            } else {
                // Check if it's a body type
                const bt = options.value.bodyTypes.find(x => x.slug === segments[1])
                if (bt) {
                    filters.bodyTypes = [bt.id]
                }
            }
        }
    } else if (segments[0] && segments[0].startsWith('volvo-')) {
        // Handle body type URL pattern: /volvo-{bodyType}
        const bodyTypeSlug = segments[0].substring(6) // Remove 'volvo-' prefix
        const bt = options.value.bodyTypes.find(x => x.slug === bodyTypeSlug)
        if (bt) {
            filters.bodyTypes = [bt.id]
        }
    } else {
        // Check if it's a brand URL (e.g., /mg)
        const br = options.value.brands.find(x => x.slug === segments[0])
        if (br) {
            filters.brands = [br.id]
        } else {
            // availability slug
            if (segments[0]) {
                const at = options.value.availabilityTypes.find(x => x.slug === segments[0])
                if (at) filters.availabilityTypes = [at.id]
            }
        }

        // Check for availability type + brand pattern (e.g., /nove-vozy/mg)
        if (segments.length >= 2) {
            // If segment[0] is an availability type and segment[1] is a brand
            const at = options.value.availabilityTypes.find(x => x.slug === segments[0])
            const br = options.value.brands.find(x => x.slug === segments[1])

            if (at && br) {
                filters.availabilityTypes = [at.id]
                filters.brands = [br.id]
            } else {
                // model series slug (original behavior)
                const md = options.value.models.find(x => x.slug === segments[1])
                if (md) filters.models = [md.id]
            }
        }

        // Check for availability type + brand + model pattern (e.g., /nove-vozy/mg/zs)
        if (segments.length >= 3) {
            const at = options.value.availabilityTypes.find(x => x.slug === segments[0])
            const br = options.value.brands.find(x => x.slug === segments[1])
            const md = options.value.models.find(x => x.slug === segments[2])

            if (at && br && md) {
                filters.availabilityTypes = [at.id]
                filters.brands = [br.id]
                filters.models = [md.id]
            }
        }
    }

    // 3.5) Apply default filter values from props (e.g., from preset URLs like /ovoce)
    // Only set defaults if the filter is not already set from URL parameters
    if (props.defaultCategoryId && !filters.categories.length) {
        filters.categories = [Number(props.defaultCategoryId)]
    }
    if (props.defaultBodyTypeId && !filters.bodyTypes.length) {
        filters.bodyTypes = [Number(props.defaultBodyTypeId)]
    }
    if (props.defaultFuelTypeId && !filters.fuelTypes.length) {
        filters.fuelTypes = [Number(props.defaultFuelTypeId)]
    }
    if (props.defaultCarModelId && !filters.models.length) {
        filters.models = [Number(props.defaultCarModelId)]
    }
    if (props.defaultAvailabilityTypeId && !filters.availabilityTypes.length) {
        filters.availabilityTypes = [Number(props.defaultAvailabilityTypeId)]
    }
    if (props.defaultBrandId && !filters.brands.length) {
        filters.brands = [Number(props.defaultBrandId)]
    }
    if ((props.defaultVolvoSelekt === true || props.defaultVolvoSelekt === 'true') && !filters.volvoSelektOnly) {
        filters.volvoSelektOnly = true
    }
    if ((props.defaultIsInStock === true || props.defaultIsInStock === 'true') && !filters.isInStock) {
        filters.isInStock = true
    }

    // 4) Načti výsledky pro aktuální stránku pouze pokud nemáme serverový initial state
    // Metadata (nadpis, breadcrumbs, chipsy) jsou součástí server payloadu i results endpointu
    const hasQueryFilters = window.location.search.length > 0

    if (hasInitialResults && !hasQueryFilters) {
        applyPresentData(props.initialPresent)
        dispatchDataLayerEvent(offers.value)
        updateStructuredData(offers.value)
    } else {
        await fetchResults(currentPage.value, false, hasQueryFilters)
    }

    // 6) Fetch all banner slides once and cache them
    await fetchAllBannerSlides()

    // 7) Odemkni watchery, aby se teď už spouštěly při jakékoli změně filtrů
    isInitialLoad.value = false
    activateHydratedUi()

    await setupShowFilterWrapObserver()

    shouldRefreshResultsAfterBfcacheRestore.value = true
})

window.addEventListener('pageshow', async event => {
    if (!event.persisted || !shouldRefreshResultsAfterBfcacheRestore.value || isInitialLoad.value) {
        return
    }

    await fetchResults(currentPage.value, false, true)
})

// Unmounted
onUnmounted(() => {
    teardownShowFilterWrapObserver()
})

watch(siteId, async newSiteId => {
    if (newSiteId === 1) {
        await setupShowFilterWrapObserver()
        return
    }

    teardownShowFilterWrapObserver()
})

// Cookie utility functions
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return '';
}

function setCookie(name, value, days = 180) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `; expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}${expires}; path=/`;
}

// Add/remove favorites/comparison
async function addToFavorites(payload) {
    const { id, offer } = normalizeOfferEventPayload(payload)
    if (!id) {
        return
    }

    try {
        if (isAuthenticated.value) {
            // For authenticated users, use API
            await axios.post('/api/v1/favorites', { offer_id: id });
        } else {
            // For unauthenticated users, use API which will set cookies
            await axios.post('/api/v1/favorites', { offer_id: id });
        }

        // Update local state
        if (!favorites.value.includes(id)) {
            favorites.value.push(id);
        }

        const offerDetails = await resolveOfferForDataLayer(id, offer)
        dispatchFavoritesDataLayerEventForOffer(id, offerDetails, 'add_to_favorites')

        // Dispatch event for header component
        window.dispatchEvent(new CustomEvent('favoriteCarAdded'));
    } catch (error) {
        console.error('Error adding car to favorites:', error);
    }
}

async function removeFromFavorites(payload) {
    const { id, offer } = normalizeOfferEventPayload(payload)
    if (!id) {
        return
    }

    try {
        if (isAuthenticated.value) {
            // For authenticated users, use API
            await axios.delete(`/api/v1/favorites/${id}`);
        } else {
            // For unauthenticated users, use API which will update cookies
            await axios.delete(`/api/v1/favorites/${id}`);
        }

        // Update local state
        favorites.value = favorites.value.filter(i => i !== id);

        const offerDetails = await resolveOfferForDataLayer(id, offer)
        dispatchFavoritesDataLayerEventForOffer(id, offerDetails, 'remove_from_favorites')

        // Dispatch event for header component
        window.dispatchEvent(new CustomEvent('favoriteCarRemoved'));
    } catch (error) {
        console.error('Error removing car from favorites:', error);
    }
}

async function addToComparison(payload) {
    const { id, offer } = normalizeOfferEventPayload(payload)
    if (!id) {
        return
    }

    // Check if the comparison list has reached the maximum limit (10 cars)
    const maxComparedCars = 10;
    if (comparisonList.value.length >= maxComparedCars) {
        // Show a flash message to the user
        flashMessageService.showDanger(props.lblComparedCarsLimitReached || 'Můžete porovnávat maximálně 10 vozů najednou.');
        return;
    }

    try {
        // Use API for both authenticated and unauthenticated users
        // The API will handle setting cookies for unauthenticated users
        await axios.post('/api/v1/compare', { offer_id: id });

        // Update local state
        if (!comparisonList.value.includes(id)) {
            comparisonList.value.push(id);
        }

        const offerDetails = await resolveOfferForDataLayer(id, offer);
        dispatchComparisonDataLayerEventForOffer(id, offerDetails, 'add_to_comparison');

        // Dispatch event for header component
        window.dispatchEvent(new CustomEvent('carAddedToComparison'));
    } catch (error) {
        // Handle the error from the backend (e.g., if the limit is reached)
        if (error.response && error.response.status === 422) {
            flashMessageService.showDanger(props.lblComparedCarsLimitReached || 'Můžete porovnávat maximálně 10 vozů najednou.');
        } else {
            console.error('Error adding car to comparison:', error);
        }
    }
}

async function removeFromComparison(payload) {
    const { id, offer } = normalizeOfferEventPayload(payload)
    if (!id) {
        return
    }

    try {
        // Use API for both authenticated and unauthenticated users
        // The API will handle updating cookies for unauthenticated users
        await axios.delete(`/api/v1/compare/${id}`);

        // Update local state
        comparisonList.value = comparisonList.value.filter(i => i !== id);

        const offerDetails = await resolveOfferForDataLayer(id, offer);
        dispatchComparisonDataLayerEventForOffer(id, offerDetails, 'remove_from_comparison');

        // Dispatch event for header component
        window.dispatchEvent(new CustomEvent('carRemovedFromComparison'));
    } catch (error) {
        console.error('Error removing car from comparison:', error);
    }
}

async function clearComparisonList() {
    try {
        const idsToRemove = [...comparisonList.value];
        for (const id of idsToRemove) {
            await removeFromComparison(id);
        }
        comparisonList.value = [];
    } catch (error) {
        // console.error('Error clearing comparison list:', error);
    }
}

function onToggleDropdown(id) { openDropdownId.value = openDropdownId.value === id ? null : id }
function removeFilter(name, value, optionId) {
    if (name === 'additionalAttributes') {
        if (optionId !== undefined) {
            // For array attributes with options, remove the specific option
            if (Array.isArray(filters.additionalAttributes[value])) {
                filters.additionalAttributes[value] = filters.additionalAttributes[value].filter(id => id !== optionId)

                // If the array is empty, remove the attribute
                if (filters.additionalAttributes[value].length === 0) {
                    delete filters.additionalAttributes[value]
                }
            }
        } else {
            // For boolean attributes, remove the attribute
            delete filters.additionalAttributes[value]
        }
    } else if (name === 'priceFrom') {
        filters.priceFrom = null
    } else if (name === 'priceTo') {
        filters.priceTo = null
    } else if (name === 'mileageFrom') {
        filters.mileageFrom = null
    } else if (name === 'mileageTo') {
        filters.mileageTo = null
    } else if (name === 'ageFrom') {
        filters.ageFrom = null
    } else if (name === 'ageTo') {
        filters.ageTo = null
    } else if (Array.isArray(filters[name])) {
        filters[name] = filters[name].filter(v => v !== value)
    } else {
        filters[name] = false
    }
}
function clearFilters() {
    filters.brands = []
    filters.availabilityTypes = []
    filters.showrooms = []
    filters.models = []
    filters.fuelTypes = []
    filters.transmissionTypes = []
    filters.bodyTypes = []
    filters.bodyColors = []
    filters.categories = []
    filters.priceFrom = null
    filters.priceTo = null
    filters.mileageFrom = null
    filters.mileageTo = null
    filters.ageFrom = null
    filters.ageTo = null
    filters.vatDeductibleOnly = false
    filters.volvoSelektOnly = false
    filters.isInStock = false
    filters.additionalAttributes = {}
    filters.customTags = []

    // Immediately clear model series chips since no filters are selected
    modelSeriesChips.value = []
}

function handleCarSelected(offer) {
    if (!offer) {
        return
    }

    dispatchFilterCarSelectDataLayerEvent(offer)
}

// Get image URL for a slide
function getSlideImage(slide, purposeKey) {
    if (!slide.images) return null
    const image = slide.images.find(img => img.purpose === IMAGE_PURPOSES[purposeKey])
    if (!image) return null

    // Use the AWS S3 URL structure
    // The bucket name is 'apruhonice' and the region is 'eu-central-1' from the config
    if (image.uuid && image.extension) {
        const prefix = image.uuid.substring(0, 2)

        // Use original variant for desktop images (XLARGE and LARGE)
        if (purposeKey === 'PURPOSE_BANNER_XLARGE_IMAGE' || purposeKey === 'PURPOSE_BANNER_LARGE_IMAGE') {
            return `https://apruhonice.s3.eu-central-1.amazonaws.com/${prefix}/${image.uuid}.${image.extension}`
        }

        // Use full variant for mobile images (MEDIUM and SMALL)
        return `https://apruhonice.s3.eu-central-1.amazonaws.com/${prefix}/${image.uuid}.full.${image.extension}`
    }

    return null
}

// Fetch all banner slides once and cache them
async function fetchAllBannerSlides() {
    try {
        // console.log('Fetching all banner slides for car filter')
        const response = await axios.get('/api/v1/banner-slides/all-for-car-filter')
        allBannerSlides.value = response.data
        // console.log('All banner slides fetched:', allBannerSlides.value)

        // Initial filtering of banners based on current filters
        filterBannerSlides()
    } catch (error) {
        // console.error('Error fetching all banner slides:', error)
        allBannerSlides.value = null
        bannerSlides.value = []
        bottomBannerSlides.value = []
    }
}

// Filter banner slides based on current filters
function filterBannerSlides() {
    if (!allBannerSlides.value) {
        // console.log('No banner slides to filter')
        bannerSlides.value = []
        bottomBannerSlides.value = []
        return
    }

    // console.log('Filtering banner slides with filters:', {
    //     availabilityTypes: filters.availabilityTypes,
    //     models: filters.models,
    //     brands: filters.brands
    // })

    // Filter top banners
    bannerSlides.value = findMatchingSlides('top')

    // Filter bottom banners
    bottomBannerSlides.value = findMatchingSlides('bottom')

    // console.log('Filtered banner slides:', {
    //     top: bannerSlides.value.length,
    //     bottom: bottomBannerSlides.value.length
    // })
}

// Helper function to find matching slides for a position
function findMatchingSlides(position) {
    if (!allBannerSlides.value || !allBannerSlides.value[position]) {
        return []
    }

    const positionSlides = allBannerSlides.value[position]
    const availabilityTypes = filters.availabilityTypes
    const models = filters.models
    const brands = filters.brands

    // Check if we're on a URL that combines availability type and brand
    const isAvailabilityAndBrandUrl = availabilityTypes.length > 0 && brands.length > 0

    // First try to find specific slides matching availability types, models, and brands
    if ((availabilityTypes.length > 0 || models.length > 0 || brands.length > 0) && positionSlides.specific) {
        const matchingSlides = positionSlides.specific.filter(slide => {
            return (availabilityTypes.length === 0 || (slide.car_availability_type_id !== null && availabilityTypes.includes(slide.car_availability_type_id))) &&
                   (models.length === 0 || (slide.car_model_id !== null && models.includes(slide.car_model_id))) &&
                   (brands.length === 0 || (slide.car_brand_id !== null && brands.includes(slide.car_brand_id)))
        })

        if (matchingSlides.length > 0) {
            return matchingSlides.slice(0, 10) // Limit to 5 slides
        }
    }

    // Then try to find specific slides matching only availability types
    if (availabilityTypes.length > 0 && positionSlides.specific) {
        const matchingSlides = positionSlides.specific.filter(slide => {
            return slide.car_availability_type_id !== null &&
                   availabilityTypes.includes(slide.car_availability_type_id) &&
                   slide.car_model_id === null &&
                   slide.car_brand_id === null
        })

        if (matchingSlides.length > 0) {
            return matchingSlides.slice(0, 10)
        }
    }

    // Then try to find specific slides matching only models
    if (models.length > 0 && positionSlides.specific) {
        const matchingSlides = positionSlides.specific.filter(slide => {
            return slide.car_model_id !== null &&
                   models.includes(slide.car_model_id) &&
                   slide.car_availability_type_id === null &&
                   slide.car_brand_id === null
        })

        if (matchingSlides.length > 0) {
            return matchingSlides.slice(0, 10)
        }
    }

    // Then try to find specific slides matching only brands
    // Only show brand-specific slides if we're not on a URL that combines availability type and brand
    if (brands.length > 0 && !isAvailabilityAndBrandUrl && positionSlides.specific) {
        const matchingSlides = positionSlides.specific.filter(slide => {
            return slide.car_brand_id !== null &&
                   brands.includes(slide.car_brand_id) &&
                   slide.car_availability_type_id === null &&
                   slide.car_model_id === null
        })

        if (matchingSlides.length > 0) {
            return matchingSlides.slice(0, 10)
        }
    }

    // Try specific fallback slides
    if ((availabilityTypes.length > 0 || models.length > 0 || brands.length > 0) && positionSlides.specificFallback) {
        // For brand-specific slides, only include them if we're not on a URL that combines availability type and brand
        const matchingSlides = positionSlides.specificFallback.filter(slide => {
            // If it's a brand-specific slide (only car_brand_id is set) and we're on a combined URL, skip it
            if (slide.car_brand_id !== null &&
                slide.car_availability_type_id === null &&
                slide.car_model_id === null &&
                isAvailabilityAndBrandUrl) {
                return false;
            }

            return (availabilityTypes.length === 0 || (slide.car_availability_type_id !== null && availabilityTypes.includes(slide.car_availability_type_id))) &&
                   (models.length === 0 || (slide.car_model_id !== null && models.includes(slide.car_model_id))) &&
                   (brands.length === 0 || (slide.car_brand_id !== null && brands.includes(slide.car_brand_id)))
        })

        if (matchingSlides.length > 0) {
            return matchingSlides.slice(0, 10)
        }
    }

    // Try generic slides (no specific filters)
    if (positionSlides.generic && positionSlides.generic.length > 0) {
        return positionSlides.generic.slice(0, 10)
    }

    // Finally, try generic fallback slides
    if (positionSlides.genericFallback && positionSlides.genericFallback.length > 0) {
        return positionSlides.genericFallback.slice(0, 10)
    }

    return []
}

// Legacy function for compatibility - now just calls filterBannerSlides
async function fetchBannerSlides() {
    // If we haven't fetched all slides yet, do it now
    if (!allBannerSlides.value) {
        await fetchAllBannerSlides()
    } else {
        // Otherwise just filter the existing slides
        filterBannerSlides()
    }
}

// Check if user is authenticated
const isAuthenticated = ref(false)

// Check authentication status on mount
async function checkAuthStatus() {
    try {
        const response = await axios.get('/api/v1/auth/check')
        isAuthenticated.value = response.data.authenticated
    } catch (error) {
        // console.error('Error checking authentication status:', error)
        isAuthenticated.value = false
    }
}

// Fetch compared cars directly from API
async function fetchComparedCars() {
    try {
        const response = await axios.get('/api/v1/compare')
        comparisonList.value = response.data.map(car => car.id)
    } catch (error) {
        comparisonList.value = []
    }
}

// Fetch favorite cars directly from API
async function fetchFavoriteCars() {
    try {
        const response = await axios.get('/api/v1/favorites')
        favorites.value = response.data.ids || []
    } catch (error) {
        favorites.value = []
    }
}

// Generate and dispatch data layer payload
function dispatchDataLayerEvent(carOffers) {
    // Create the data layer payload
    const payload = {
        event: 'filter_cars',
        pagination: currentPage.value,
        filter: {
            condition: getFilterNames(options.value.availabilityTypes, filters.availabilityTypes),
            branch: getFilterNames(options.value.showrooms, filters.showrooms),
            model: getFilterNames(options.value.models, filters.models),
            color: getFilterNames(options.value.bodyColors, filters.bodyColors),
            body: getFilterNames(options.value.bodyTypes, filters.bodyTypes),
            category: getFilterNames(options.value.categories, filters.categories),
            fuel: getFilterNames(options.value.fuelTypes, filters.fuelTypes),
            age: filters.ageTo ? parseInt(filters.ageTo) : 0,
            mileage_from: filters.mileageFrom || 0,
            mileage_to: filters.mileageTo || 0,
            price_from: filters.priceFrom || 0,
            price_to: filters.priceTo || 0,
            transmission: getFilterNames(options.value.transmissionTypes, filters.transmissionTypes),
            sort: sort.value || 'default',
            result_count: total.value,
        },
        cars: carOffers.map(offer => formatCarForDataLayer(offer)),
    }

    // Dispatch the custom event
    window.dispatchEvent(new CustomEvent('carFilter.resultsUpdated', {
        detail: { payload }
    }))
}

// Helper function to get filter names joined by |
function getFilterNames(options, selectedIds) {
    if (!selectedIds || !selectedIds.length) return ''
    return options
        .filter(option => selectedIds.includes(option.id))
        .map(option => option.name)
        .join('|')
}

// Get current filter settings for saved filter
function getCurrentFilterSettings() {
    return {
        availabilityTypes: filters.availabilityTypes,
        showrooms: filters.showrooms,
        models: filters.models,
        fuelTypes: filters.fuelTypes,
        transmissionTypes: filters.transmissionTypes,
        bodyTypes: filters.bodyTypes,
        bodyColors: filters.bodyColors,
        categories: filters.categories,
        priceFrom: filters.priceFrom,
        priceTo: filters.priceTo,
        mileageFrom: filters.mileageFrom,
        mileageTo: filters.mileageTo,
        ageFrom: filters.ageFrom,
        ageTo: filters.ageTo,
        vatDeductibleOnly: filters.vatDeductibleOnly,
        volvoSelektOnly: filters.volvoSelektOnly,
        isInStock: filters.isInStock,
        additionalAttributes: filters.additionalAttributes,
    }
}

// Get current filter results for saved filter
function getCurrentFilterResults() {
    return offers.value.map(offer => offer.id)
}

// Format car data for data layer
function formatCarForDataLayer(offer) {
    const car = offer.car
    const cat = offer.car_availability_type || car.car_availability_type

    // Handle the color object which might be a complex object with id, name, hex, etc.
    let colorValue = ''
    if (car.carBodyColor) {
        colorValue = car.carBodyColor.name || ''
    } else if (car.body_color && typeof car.body_color === 'object') {
        colorValue = car.body_color.name || ''
    } else {
        colorValue = car.body_color || ''
    }

    // Handle the model field
    let modelValue = ''
    if (car.car_model && typeof car.car_model === 'object') {
        modelValue = car.car_model.name || ''
    } else if (car.carModel && typeof car.carModel === 'object') {
        modelValue = car.carModel.name || ''
    } else if (car.model && typeof car.model === 'object') {
        modelValue = car.model.name || ''
    }

    // Handle the condition field
    let conditionValue = ''
    if (cat && typeof cat === 'object') {
        conditionValue = cat.name || ''
    } else if (car.availability_type && typeof car.availability_type === 'object') {
        conditionValue = car.availability_type.name || ''
    } else if (car.carAvailabilityType && typeof car.carAvailabilityType === 'object') {
        conditionValue = car.carAvailabilityType.name || ''
    } else if (offer.availability_type && typeof offer.availability_type === 'object') {
        conditionValue = offer.availability_type.name || ''
    }

    return {
        id: offer.id || '',
        model: modelValue,
        price: Math.round(parseFloat(offer.price) || 0),
        condition: conditionValue,
        year: parseInt(car.year_of_manufacture || 0),
        mileage: parseInt(car.current_mileage || 0),
        seats: parseInt(car.number_of_seats || 0),
        color: colorValue,
        body: car.bodyType?.name || car.body_type?.name || '',
        power: car.engine_power_kw ? `${car.engine_power_kw} kW` : '',
        engine_displacement: parseInt(car.engine_volume || 0),
        fuel: car.fuelType?.name || car.fuel_type?.name || '',
        consumption: car.fuel_consumption ? `${car.fuel_consumption} l/100km` : '',
        transmission: car.transmissionType?.name || car.transmission_type?.name || ''
    }
}

function cacheOfferForComparison(offer) {
    if (!offer || typeof offer !== 'object') {
        return
    }

    const numericId = toNumericId(offer.id)
    if (numericId === null) {
        return
    }

    comparisonCarDetailsCache.set(numericId, offer)
    trimComparisonCacheIfNeeded()
}

function rememberOffersForComparison(offerList) {
    if (!Array.isArray(offerList)) {
        return
    }

    offerList.forEach(cacheOfferForComparison)
}

function trimComparisonCacheIfNeeded() {
    while (comparisonCarDetailsCache.size > COMPARISON_DETAILS_CACHE_LIMIT) {
        const oldestKey = comparisonCarDetailsCache.keys().next().value
        comparisonCarDetailsCache.delete(oldestKey)
    }
}

function normalizeOfferEventPayload(payload) {
    if (payload && typeof payload === 'object') {
        if ('offer' in payload) {
            const id = toNumericId(payload.id ?? payload.offer?.id ?? null)
            return { id, offer: payload.offer || null }
        }

        if ('id' in payload) {
            return { id: toNumericId(payload.id), offer: payload.offer ?? null }
        }

        if ('car' in payload || 'detail_link' in payload) {
            return { id: toNumericId(payload.id ?? null), offer: payload }
        }
    }

    return { id: toNumericId(payload), offer: null }
}

function toNumericId(value) {
    if (value === null || typeof value === 'undefined') {
        return null
    }

    const numeric = Number(value)
    return Number.isNaN(numeric) ? null : numeric
}

async function resolveOfferForDataLayer(id, providedOffer = null) {
    const numericId = toNumericId(id)
    if (!numericId && numericId !== 0) {
        return null
    }

    if (providedOffer) {
        cacheOfferForComparison(providedOffer)
        return providedOffer
    }

    if (comparisonCarDetailsCache.has(numericId)) {
        return comparisonCarDetailsCache.get(numericId)
    }

    const offerFromState = offers.value.find(offer => toNumericId(offer.id) === numericId)
    if (offerFromState) {
        cacheOfferForComparison(offerFromState)
        return offerFromState
    }

    try {
        const { data } = await axios.get(`/api/v1/car-offers/${numericId}`)
        if (data) {
            cacheOfferForComparison(data)
            return data
        }
    } catch (error) {
        console.error('Error fetching offer for comparison data layer:', error)
    }

    return null
}

function buildFallbackCarPayload(id) {
    return {
        id: id ?? '',
        model: '',
        price: 0,
        condition: '',
        year: 0,
        mileage: 0,
        seats: 0,
        color: '',
        body: '',
        power: '',
        engine_displacement: 0,
        fuel: '',
        consumption: '',
        transmission: ''
    }
}

function dispatchFilterCarSelectDataLayerEvent(offer) {
    if (!offer) {
        return
    }

    let carPayload
    try {
        carPayload = formatCarForDataLayer(offer)
    } catch (error) {
        carPayload = buildFallbackCarPayload(offer?.id)
    }

    const payload = {
        event: 'filter_cars_select',
        car: carPayload,
    }

    window.dispatchEvent(new CustomEvent('filterCarSelected', {
        detail: { payload }
    }))
}

function dispatchComparisonDataLayerEventForOffer(id, offer, eventCode) {
    if (!id && !offer) {
        return
    }

    let carPayload
    if (offer) {
        try {
            carPayload = formatCarForDataLayer(offer)
        } catch (error) {
            carPayload = buildFallbackCarPayload(id)
        }
    } else {
        carPayload = buildFallbackCarPayload(id)
    }

    const payload = {
        event: eventCode,
        car: carPayload,
    }

    window.dispatchEvent(new CustomEvent('carAddedOrRemovedFromComparison', {
        detail: { payload }
    }))
}

function dispatchFavoritesDataLayerEventForOffer(id, offer, eventCode) {
    if (!id && !offer) {
        return
    }

    let carPayload
    if (offer) {
        try {
            carPayload = formatCarForDataLayer(offer)
        } catch (error) {
            carPayload = buildFallbackCarPayload(id)
        }
    } else {
        carPayload = buildFallbackCarPayload(id)
    }

    const payload = {
        event: eventCode,
        car: carPayload,
    }

    const userPayload = buildUserPayloadForFavorites()
    if (userPayload) {
        payload.user = userPayload
    }

    window.dispatchEvent(new CustomEvent('carAddedOrRemovedFromFavorites', {
        detail: { payload }
    }))
}

function buildUserPayloadForFavorites() {
    const favoriteCount = favorites.value.length
    const existingUser = getDataLayerUserContext()
    if (existingUser) {
        return {
            ...existingUser,
            favorite_cars: {
                ...(existingUser.favorite_cars || {}),
                count_all: favoriteCount,
            },
        }
    }

    const sessionId = getCookie('laravel_session') || 'guest'

    return {
        id: sessionId || 'guest',
        favorite_cars: {
            count_all: favoriteCount,
        },
    }
}

function getDataLayerUserContext() {
    if (typeof window === 'undefined' || !Array.isArray(window.dataLayer)) {
        return null
    }

    for (let i = window.dataLayer.length - 1; i >= 0; i--) {
        const entry = window.dataLayer[i]
        if (entry && entry.user) {
            return entry.user
        }
    }

    return null
}

// Update structured data (JSON-LD) with current offers
function updateStructuredData(carOffers) {
    if (!carOffers || carOffers.length === 0) {
        // Remove dynamic schema if no offers
        const existingSchema = document.getElementById('dynamic-schema-org-data')
        if (existingSchema) {
            existingSchema.remove()
        }
        return
    }

    // Build ItemList with Product + Vehicle schemas
    const itemListElements = carOffers.map((offer, index) => {
        const car = offer.car
        const images = car.images || []
        const mainImage = images.find(img => img.purpose === 1) || images[0]

        return {
            "@type": "ListItem",
            "position": index + 1,
            "item": {
                "@type": ["Product", "Car"],
                "name": `${car.year_of_manufacture || ''} ${car.car_brand?.name || ''} ${car.car_model?.name || ''} ${car.imported_name || ''}`.trim(),
                "url": offer.detail_link || '',
                ...(mainImage && {
                    "image": mainImage.box_path || mainImage.full_path || ''
                }),
                ...(offer.price && {
                    "offers": {
                        "@type": "Offer",
                        "price": Math.round(parseFloat(offer.price) || 0),
                        "priceCurrency": "CZK",
                        "availability": (() => {
                            const status = car.status
                            if (status === 'in-stock' || status === 'new') return 'https://schema.org/InStock'
                            if (status === 'reserved') return 'https://schema.org/PreOrder'
                            if (status === 'sold') return 'https://schema.org/SoldOut'
                            if (status === 'deactivated') return 'https://schema.org/Discontinued'
                            return 'https://schema.org/InStock' // default
                        })()
                    }
                }),
                ...(car.year_of_manufacture && { "vehicleModelDate": car.year_of_manufacture }),
                ...(car.car_brand?.name && { "brand": { "@type": "Brand", "name": car.car_brand.name } }),
                ...(car.car_model?.name && { "model": car.car_model.name }),
                ...(car.body_type?.name && { "bodyType": car.body_type.name }),
                ...(car.fuel_type?.name && { "fuelType": car.fuel_type.name }),
                ...(car.transmission_type?.name && { "vehicleTransmission": car.transmission_type.name }),
                ...(car.current_mileage && { "mileageFromOdometer": { "@type": "QuantitativeValue", "value": car.current_mileage, "unitCode": "KMT" } }),
                ...(car.engine_power_kw && { "vehicleEngine": { "@type": "EngineSpecification", "enginePower": { "@type": "QuantitativeValue", "value": car.engine_power_kw, "unitCode": "KWT" } } })
            }
        }
    })

    const schemaData = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "numberOfItems": total.value || carOffers.length,
        "itemListElement": itemListElements
    }

    // Find or create script element
    let schemaScript = document.getElementById('dynamic-schema-org-data')
    if (!schemaScript) {
        schemaScript = document.createElement('script')
        schemaScript.type = 'application/ld+json'
        schemaScript.id = 'dynamic-schema-org-data'
        document.head.appendChild(schemaScript)
    }

    // Update content
    schemaScript.textContent = JSON.stringify(schemaData, null, 2)
}
</script>

<style scoped>
.carFilterContainer {
    margin-bottom: 5rem;
}

/* Loading overlay styles */
.loading-overlay {
    position: fixed;
    top: 0; left: 0;
    width: 100vw; height: 100vh;
    z-index: 10000;
}

/* jemný půlprůhledný podklad */
.overlay-backdrop {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    background: rgba(0, 0, 0, 0.5);
}

/* box se spinnerem a textem */
.spinner-container {
    position: absolute;
    top: 40vh;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.6);
    padding: 1rem 2rem;
    color: #fff;
    border-radius: 0.5rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    z-index: 10001;
}

/* animace SVG spinneru */
.spinner-icon {
    width: 2rem;
    height: 2rem;
    animation: rotate 1.5s linear infinite;
}
.spinner-icon .path {
    stroke: currentColor;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
}
@keyframes rotate {
    100% { transform: rotate(360deg); }
}
@keyframes dash {
    0%   { stroke-dasharray: 1,150; stroke-dashoffset: 0; }
    50%  { stroke-dasharray: 90,150; stroke-dashoffset: -35; }
    100% { stroke-dasharray: 90,150; stroke-dashoffset: -124; }
}

/* Consolidated skeleton loading styles for all subcomponents */
/* Common skeleton styles */
:deep(.skeleton-text) {
    height: 16px;
    background-color: #f0f0f0;
    border-radius: 4px;
    margin-bottom: 10px;
    position: relative;
    overflow: hidden;
}

:deep(.skeleton-text::after),
:deep(.skeleton-title::after),
:deep(.skeleton-tag::after),
:deep(.skeleton-dropdown::after),
:deep(.skeleton-card-image::after),
:deep(.skeleton-card-title::after),
:deep(.skeleton-card-subtitle::after),
:deep(.skeleton-card-detail::after),
:deep(.skeleton-card-price::after),
:deep(.skeleton-card-actions::after),
:deep(.skeleton-pagination::after),
:deep(.skeleton-slide::after),
:deep(.skeleton-pulse) {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}

:deep(.skeleton-pulse)::after,
:deep(.skeleton-circle::after),
:deep(.skeleton-slider::after),
:deep(.skeleton-button::after) {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.6) 50%,
        rgba(255, 255, 255, 0) 100%);
    animation: pulse 1.5s infinite;
}

.site-6 :deep(.skeleton-text),
.site-6 :deep(.skeleton-slide),
.site-6 :deep(.skeleton-title),
.site-6 :deep(.skeleton-check-item::before),
.site-6 :deep(.skeleton-check-item::after),
.site-6 :deep(.skeleton-slider),
.site-6 :deep(.skeleton-button),
.site-6 :deep(.skeleton-circle),
.site-6 :deep(.skeleton-tag),
.site-6 :deep(.skeleton-dropdown),
.site-6 :deep(.skeleton-card-image),
.site-6 :deep(.skeleton-card-title),
.site-6 :deep(.skeleton-card-subtitle),
.site-6 :deep(.skeleton-card-detail),
.site-6 :deep(.skeleton-card-price),
.site-6 :deep(.skeleton-card-actions),
.site-6 :deep(.skeleton-pagination),
.site-6 .skeleton-toggle-switch,
.site-6 .skeleton-toggle-text {
    background-color: #1C1C1C;
}

.site-6 .skeleton-toggle-switch::after {
    background-color: #2A2A2A;
}

.site-6 :deep(.skeleton-pulse)::after,
.site-6 :deep(.skeleton-circle::after),
.site-6 :deep(.skeleton-slider::after),
.site-6 :deep(.skeleton-button::after) {
    background: linear-gradient(90deg,
        rgba(28, 28, 28, 0) 0%,
        rgba(28, 28, 28, 0.6) 50%,
        rgba(28, 28, 28, 0) 100%);
}

@keyframes pulse {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(100%);
    }
}

/* BannerSlider skeleton styles */
:deep(.skeleton-banner) {
    height: 272px;
}

@media (max-width: 575px) {
    :deep(.skeleton-banner) {
        height: 180px;
    }
}

:deep(.skeleton-slide) {
    width: 100%;
    height: 100%;
    background-color: #f0f0f0;
    border-radius: 0.3rem;
    overflow: hidden;
    position: relative;
}

@media (min-width: 992px) {
    :deep(.skeleton-slide) {
        border-radius: 0.8rem;
    }
}

/* CarFilterSidebar skeleton styles */
:deep(.filter-skeleton) {
    min-height: 100%;
    position: relative;
}

:deep(.skeleton-title) {
    width: 70%;
    height: 20px;
    margin-bottom: 15px;
    background-color: #f0f0f0;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
}

:deep(.skeleton-text-sm) {
    width: 90%;
    height: 12px;
}

:deep(.skeleton-check-item) {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    position: relative;
}

:deep(.skeleton-check-item::before) {
    content: '';
    width: 16px;
    height: 16px;
    background-color: #f0f0f0;
    border-radius: 3px;
    margin-right: 10px;
    display: inline-block;
}

:deep(.skeleton-check-item::after) {
    content: '';
    width: calc(100% - 30px);
    height: 16px;
    background-color: #f0f0f0;
    border-radius: 4px;
    display: inline-block;
    position: relative;
    overflow: hidden;
}

:deep(.skeleton-check-item-image) {
    padding-left: 40px;
}

:deep(.skeleton-check-item-image::before) {
    width: 30px;
    height: 30px;
    border-radius: 50%;
}

:deep(.skeleton-slider) {
    height: 30px;
    background-color: #f0f0f0;
    border-radius: 4px;
    margin-bottom: 15px;
    position: relative;
    overflow: hidden;
}

:deep(.skeleton-button) {
    height: 40px;
    background-color: #f0f0f0;
    border-radius: 4px;
    width: 100%;
    position: relative;
    overflow: hidden;
}

:deep(.skeleton-circle) {
    width: 32px;
    height: 32px;
    background-color: #f0f0f0;
    border-radius: 50%;
    position: relative;
    overflow: hidden;
}

/* CarFilterResults skeleton styles */
:deep(.results-skeleton) {
    min-height: 100%;
    position: relative;
}

:deep(.skeleton-tag-cloud) {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

:deep(.skeleton-tag) {
    height: 30px;
    background-color: #f0f0f0;
    border-radius: 15px;
    width: 100px;
    position: relative;
    overflow: hidden;
}

:deep(.skeleton-dropdown) {
    height: 38px;
    width: 200px;
    background-color: #f0f0f0;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
}

:deep(.skeleton-card) {
    height: 400px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    margin-bottom: 20px;
    position: relative;
}

.site-6 :deep(.skeleton-card) {
    background-color: #1C1C1C;
}

:deep(.skeleton-card-list) {
    height: 200px;
    display: flex;
}

:deep(.skeleton-card-image) {
    height: 200px;
    background-color: #f0f0f0;
    position: relative;
    overflow: hidden;
}

:deep(.skeleton-card-list .skeleton-card-image) {
    width: 300px;
    height: 100%;
}

:deep(.skeleton-card-content) {
    padding: 15px;
    flex: 1;
}

:deep(.skeleton-card-title) {
    height: 24px;
    background-color: #f0f0f0;
    border-radius: 4px;
    margin-bottom: 10px;
    width: 80%;
    position: relative;
    overflow: hidden;
}

:deep(.skeleton-card-subtitle) {
    height: 16px;
    background-color: #f0f0f0;
    border-radius: 4px;
    margin-bottom: 15px;
    width: 60%;
    position: relative;
    overflow: hidden;
}

:deep(.skeleton-card-details) {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 15px;
}

:deep(.skeleton-card-detail) {
    height: 16px;
    background-color: #f0f0f0;
    border-radius: 4px;
    width: 30%;
    position: relative;
    overflow: hidden;
}

:deep(.skeleton-card-price) {
    height: 24px;
    background-color: #f0f0f0;
    border-radius: 4px;
    margin-bottom: 15px;
    width: 40%;
    position: relative;
    overflow: hidden;
}

:deep(.skeleton-card-actions) {
    height: 40px;
    background-color: #f0f0f0;
    border-radius: 4px;
    width: 100%;
    position: relative;
    overflow: hidden;
}

:deep(.skeleton-pagination) {
    height: 40px;
    background-color: #f0f0f0;
    border-radius: 4px;
    width: 300px;
    position: relative;
    overflow: hidden;
}

/* Hide filter backdrop when modal is active */
:deep(.filter__backdrop) {
    display: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.6);
    opacity: 0;
    pointer-events: none;
}

:deep(.filter-active .filter__backdrop) {
    opacity: 1;
    pointer-events: all;
}

:deep(body.modal-filter-active .filter__backdrop) {
    opacity: 0;
    pointer-events: none;
}

@media (max-width: 991.98px) {
    :deep(.filter__backdrop) {
        display: block;
    }

    :deep(body.modal-filter-active .filter__backdrop) {
        display: none !important;
    }
}

#showFilterWrap {
    position: relative;
    z-index: 99;
}

.showFilterBar {
    position: relative;
    z-index: 1;
}

/* Banner placeholder to prevent content jumps */
.banner-placeholder {
    min-height: 300px; /* Desktop height */
}

@media (max-width: 991.98px) {
    .banner-placeholder {
        min-height: 240px; /* Tablet height */
    }

    .site-1 #showFilterWrap::before {
        display: none;
    }

    #showFilterWrap.is-fixed {
        min-height: var(--show-filter-wrap-height, 46px);
    }

    #showFilterWrap.is-fixed .showFilterBar {
        position: fixed;
        left: 0;
        width: 100%;
        bottom: 0;
        z-index: 100;
        box-sizing: border-box;
        padding: 15px 15px calc(15px + env(safe-area-inset-bottom, 0px));
        margin: 0 !important;
        background: #fff;
        box-shadow: 0 -8px 24px rgba(33, 42, 65, 0.08);
    }
}

@media (max-width: 575.98px) {
    .banner-placeholder {
        min-height: 150px; /* Mobile height */
    }

    #showFilterWrap.is-fixed .showFilterBar {
        padding: 12px 12px calc(12px + env(safe-area-inset-bottom, 0px));
    }
}

/* Breadcrumb placeholder to prevent content jumps on mobile */
.breadcrumb-placeholder {
    min-height: 40px; /* Height of breadcrumb container with content */
}

/* Skeleton for toggle switch */
.skeleton-toggle {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.skeleton-toggle-switch {
    width: 40px;
    height: 20px;
    background-color: #f0f0f0;
    border-radius: 10px;
    position: relative;
}

.skeleton-toggle-switch::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 16px;
    height: 16px;
    background-color: #e0e0e0;
    border-radius: 50%;
}

.skeleton-toggle-text {
    width: 80px;
    height: 16px;
    background-color: #f0f0f0;
    border-radius: 4px;
}
</style>
